"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FailurePlan_update_column = exports.FailurePlan_select_column = exports.FailurePlan_enum = exports.FailurePlan_constraint = exports.Custom_UnlockAccessPointResult = exports.Credential_update_column = exports.Credential_select_column = exports.Credential_constraint = exports.CredentialType_update_column = exports.CredentialType_select_column = exports.CredentialType_enum = exports.CredentialType_constraint = exports.Beacon_update_column = exports.Beacon_select_column = exports.Beacon_constraint = exports.BeaconPassword_update_column = exports.BeaconPassword_select_column = exports.BeaconPassword_constraint = exports.AuthMethod_update_column = exports.AuthMethod_select_column = exports.AuthMethod_enum = exports.AuthMethod_constraint = exports.AugustRemoteOperation = exports.ApiKey_update_column = exports.ApiKey_select_column = exports.ApiKey_constraint = exports.Announcement_update_column = exports.Announcement_select_column = exports.Announcement_constraint = exports.AccountStatus_update_column = exports.AccountStatus_select_column = exports.AccountStatus_enum = exports.AccountStatus_constraint = exports.AccessPoint_update_column = exports.AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns = exports.AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns = exports.AccessPoint_select_column = exports.AccessPoint_constraint = exports.AccessPointType_update_column = exports.AccessPointType_select_column = exports.AccessPointType_enum = exports.AccessPointType_constraint = exports.AccessPointRole_update_column = exports.AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns = exports.AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns = exports.AccessPointRole_select_column = exports.AccessPointRole_constraint = exports.AccessPointRelay_update_column = exports.AccessPointRelay_select_column = exports.AccessPointRelay_constraint = void 0;
exports.PinCodePrivate_select_column = exports.Permission_update_column = exports.Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns = exports.Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns = exports.Permission_select_column = exports.Permission_constraint = exports.PermissionScope_update_column = exports.PermissionScope_select_column = exports.PermissionScope_enum = exports.PermissionScope_constraint = exports.PermissionKey_update_column = exports.PermissionKey_select_column = exports.PermissionKey_enum = exports.PermissionKey_constraint = exports.PasswordRedacted_select_column = exports.Organization_update_column = exports.Organization_select_column = exports.Organization_constraint = exports.InputDevice_update_column = exports.InputDevice_select_column = exports.InputDevice_enum = exports.InputDevice_constraint = exports.Image_update_column = exports.Image_select_column = exports.Image_constraint = exports.Hub_update_column = exports.Hub_select_column = exports.Hub_constraint = exports.HubDeviceType_update_column = exports.HubDeviceType_select_column = exports.HubDeviceType_enum = exports.HubDeviceType_constraint = exports.HubActivationStatus_update_column = exports.HubActivationStatus_select_column = exports.HubActivationStatus_enum = exports.HubActivationStatus_constraint = exports.GpioMode_update_column = exports.GpioMode_select_column = exports.GpioMode_enum = exports.GpioMode_constraint = exports.FeatureFlag_update_column = exports.FeatureFlag_select_column = exports.FeatureFlag_constraint = exports.FeatureFlagKey_update_column = exports.FeatureFlagKey_select_column = exports.FeatureFlagKey_enum = exports.FeatureFlagKey_constraint = exports.Favorite_update_column = exports.Favorite_select_column = exports.Favorite_constraint = void 0;
exports.RoleRelationship_update_column = exports.RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns = exports.RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns = exports.RoleRelationship_select_column = exports.RoleRelationship_constraint = exports.RolePermission_update_column = exports.RolePermission_select_column = exports.RolePermission_constraint = exports.RoleKey_update_column = exports.RoleKey_select_column = exports.RoleKey_enum = exports.RoleKey_constraint = exports.Relay_update_column = exports.Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns = exports.Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns = exports.Relay_select_column = exports.Relay_constraint = exports.RelayLog_update_column = exports.RelayLog_select_column = exports.RelayLog_constraint = exports.ReaderType_update_column = exports.ReaderType_select_column = exports.ReaderType_enum = exports.ReaderType_constraint = exports.Property_update_column = exports.Property_select_column = exports.Property_constraint = exports.PropertyVirtualDirectory_update_column = exports.PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns = exports.PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns = exports.PropertyVirtualDirectory_select_column = exports.PropertyVirtualDirectory_constraint = exports.PropertySource_update_column = exports.PropertySource_select_column = exports.PropertySource_constraint = exports.PropertyMap_update_column = exports.PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns = exports.PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns = exports.PropertyMap_select_column = exports.PropertyMap_constraint = exports.PropertyMapType_update_column = exports.PropertyMapType_select_column = exports.PropertyMapType_enum = exports.PropertyMapType_constraint = exports.PropertyFeatureFlag_update_column = exports.PropertyFeatureFlag_select_column = exports.PropertyFeatureFlag_constraint = exports.PinCode_update_column = exports.PinCode_select_column = exports.PinCode_constraint = void 0;
exports.UnlockMethod_enum = exports.UnlockMethod_constraint = exports.Unit_update_column = exports.Unit_select_column = exports.Unit_constraint = exports.UnitType_update_column = exports.UnitType_select_column = exports.UnitType_enum = exports.UnitType_constraint = exports.UnitGroup_update_column = exports.UnitGroup_select_column = exports.UnitGroup_constraint = exports.Timezone_update_column = exports.Timezone_select_column = exports.Timezone_constraint = exports.Ticket_update_column = exports.Ticket_select_column = exports.Ticket_constraint = exports.TicketType_update_column = exports.TicketType_select_column = exports.TicketType_enum = exports.TicketType_constraint = exports.TicketStatus_update_column = exports.TicketStatus_select_column = exports.TicketStatus_enum = exports.TicketStatus_constraint = exports.SmartLock_update_column = exports.SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns = exports.SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns = exports.SmartLock_select_column = exports.SmartLock_constraint = exports.SmartLockLog_update_column = exports.SmartLockLog_select_column = exports.SmartLockLog_constraint = exports.SmartLockLogType_update_column = exports.SmartLockLogType_select_column = exports.SmartLockLogType_enum = exports.SmartLockLogType_constraint = exports.Session_update_column = exports.Session_select_column = exports.Session_constraint = exports.SessionType_update_column = exports.SessionType_select_column = exports.SessionType_enum = exports.SessionType_constraint = exports.Role_update_column = exports.Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns = exports.Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns = exports.Role_select_column = exports.Role_constraint = void 0;
exports.order_by = exports.cursor_ordering = exports.VirtualDirectoryUserDisplayNameFormat_update_column = exports.VirtualDirectoryUserDisplayNameFormat_select_column = exports.VirtualDirectoryUserDisplayNameFormat_enum = exports.VirtualDirectoryUserDisplayNameFormat_constraint = exports.VendorPasscode_update_column = exports.VendorPasscode_select_column = exports.VendorPasscode_constraint = exports.User_update_column = exports.User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns = exports.User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns = exports.User_select_column = exports.User_constraint = exports.UserRole_update_column = exports.UserRole_select_column = exports.UserRole_constraint = exports.UserRoleStatus_update_column = exports.UserRoleStatus_select_column = exports.UserRoleStatus_enum = exports.UserRoleStatus_constraint = exports.UserRoleReason_update_column = exports.UserRoleReason_select_column = exports.UserRoleReason_enum = exports.UserRoleReason_constraint = exports.UserRolePermission_select_column = exports.UserRoleGrantMethod_update_column = exports.UserRoleGrantMethod_select_column = exports.UserRoleGrantMethod_enum = exports.UserRoleGrantMethod_constraint = exports.UnlockResult_update_column = exports.UnlockResult_select_column = exports.UnlockResult_enum = exports.UnlockResult_constraint = exports.UnlockMethod_update_column = exports.UnlockMethod_select_column = void 0;
/** unique or primary key constraints on table "AccessPointRelay" */
var AccessPointRelay_constraint;
(function (AccessPointRelay_constraint) {
    /** unique or primary key constraint on columns "accessPointId", "relayId" */
    AccessPointRelay_constraint["AccessPointRelay_accessPointId_relayId_key"] = "AccessPointRelay_accessPointId_relayId_key";
    /** unique or primary key constraint on columns "accessPointRelayId" */
    AccessPointRelay_constraint["AccessPointRelay_pkey"] = "AccessPointRelay_pkey";
})(AccessPointRelay_constraint || (exports.AccessPointRelay_constraint = AccessPointRelay_constraint = {}));
/** select columns of table "AccessPointRelay" */
var AccessPointRelay_select_column;
(function (AccessPointRelay_select_column) {
    /** column name */
    AccessPointRelay_select_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPointRelay_select_column["accessPointRelayId"] = "accessPointRelayId";
    /** column name */
    AccessPointRelay_select_column["createdAt"] = "createdAt";
    /** column name */
    AccessPointRelay_select_column["relayId"] = "relayId";
})(AccessPointRelay_select_column || (exports.AccessPointRelay_select_column = AccessPointRelay_select_column = {}));
/** update columns of table "AccessPointRelay" */
var AccessPointRelay_update_column;
(function (AccessPointRelay_update_column) {
    /** column name */
    AccessPointRelay_update_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPointRelay_update_column["accessPointRelayId"] = "accessPointRelayId";
    /** column name */
    AccessPointRelay_update_column["createdAt"] = "createdAt";
    /** column name */
    AccessPointRelay_update_column["relayId"] = "relayId";
})(AccessPointRelay_update_column || (exports.AccessPointRelay_update_column = AccessPointRelay_update_column = {}));
/** unique or primary key constraints on table "AccessPointRole" */
var AccessPointRole_constraint;
(function (AccessPointRole_constraint) {
    /** unique or primary key constraint on columns "accessPointRoleId" */
    AccessPointRole_constraint["AccessPointRole_pkey"] = "AccessPointRole_pkey";
    /** unique or primary key constraint on columns "accessPointId", "roleId" */
    AccessPointRole_constraint["AccessPointRole_roleId_key"] = "AccessPointRole_roleId_key";
    /** unique or primary key constraint on columns "accessPointId", "roleId", "unitGroupId" */
    AccessPointRole_constraint["AccessPointRole_roleId_unitGroupId_key"] = "AccessPointRole_roleId_unitGroupId_key";
})(AccessPointRole_constraint || (exports.AccessPointRole_constraint = AccessPointRole_constraint = {}));
/** select columns of table "AccessPointRole" */
var AccessPointRole_select_column;
(function (AccessPointRole_select_column) {
    /** column name */
    AccessPointRole_select_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPointRole_select_column["accessPointRoleId"] = "accessPointRoleId";
    /** column name */
    AccessPointRole_select_column["createdAt"] = "createdAt";
    /** column name */
    AccessPointRole_select_column["hasAccess"] = "hasAccess";
    /** column name */
    AccessPointRole_select_column["roleId"] = "roleId";
    /** column name */
    AccessPointRole_select_column["schedule"] = "schedule";
    /** column name */
    AccessPointRole_select_column["unitGroupId"] = "unitGroupId";
    /** column name */
    AccessPointRole_select_column["updatedAt"] = "updatedAt";
})(AccessPointRole_select_column || (exports.AccessPointRole_select_column = AccessPointRole_select_column = {}));
/** select "AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns" columns of table "AccessPointRole" */
var AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns;
(function (AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns["hasAccess"] = "hasAccess";
})(AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns || (exports.AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns = AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns" columns of table "AccessPointRole" */
var AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns;
(function (AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns["hasAccess"] = "hasAccess";
})(AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns || (exports.AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns = AccessPointRole_select_column_AccessPointRole_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "AccessPointRole" */
var AccessPointRole_update_column;
(function (AccessPointRole_update_column) {
    /** column name */
    AccessPointRole_update_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPointRole_update_column["accessPointRoleId"] = "accessPointRoleId";
    /** column name */
    AccessPointRole_update_column["createdAt"] = "createdAt";
    /** column name */
    AccessPointRole_update_column["hasAccess"] = "hasAccess";
    /** column name */
    AccessPointRole_update_column["roleId"] = "roleId";
    /** column name */
    AccessPointRole_update_column["schedule"] = "schedule";
    /** column name */
    AccessPointRole_update_column["unitGroupId"] = "unitGroupId";
    /** column name */
    AccessPointRole_update_column["updatedAt"] = "updatedAt";
})(AccessPointRole_update_column || (exports.AccessPointRole_update_column = AccessPointRole_update_column = {}));
/** unique or primary key constraints on table "AccessPointType" */
var AccessPointType_constraint;
(function (AccessPointType_constraint) {
    /** unique or primary key constraint on columns "label" */
    AccessPointType_constraint["AccessPointType_label_key"] = "AccessPointType_label_key";
    /** unique or primary key constraint on columns "value" */
    AccessPointType_constraint["AccessPointType_pkey"] = "AccessPointType_pkey";
})(AccessPointType_constraint || (exports.AccessPointType_constraint = AccessPointType_constraint = {}));
var AccessPointType_enum;
(function (AccessPointType_enum) {
    /** Amenity */
    AccessPointType_enum["AMENITY"] = "AMENITY";
    /** Common Area */
    AccessPointType_enum["COMMON_AREA"] = "COMMON_AREA";
    /** Reservation Only */
    AccessPointType_enum["RESERVATION_ONLY"] = "RESERVATION_ONLY";
    /** Restricted (Blacklist) */
    AccessPointType_enum["RESTRICTED_BLACKLIST"] = "RESTRICTED_BLACKLIST";
    /** Restricted (Whitelist) */
    AccessPointType_enum["RESTRICTED_WHITELIST"] = "RESTRICTED_WHITELIST";
})(AccessPointType_enum || (exports.AccessPointType_enum = AccessPointType_enum = {}));
/** select columns of table "AccessPointType" */
var AccessPointType_select_column;
(function (AccessPointType_select_column) {
    /** column name */
    AccessPointType_select_column["label"] = "label";
    /** column name */
    AccessPointType_select_column["value"] = "value";
})(AccessPointType_select_column || (exports.AccessPointType_select_column = AccessPointType_select_column = {}));
/** update columns of table "AccessPointType" */
var AccessPointType_update_column;
(function (AccessPointType_update_column) {
    /** column name */
    AccessPointType_update_column["label"] = "label";
    /** column name */
    AccessPointType_update_column["value"] = "value";
})(AccessPointType_update_column || (exports.AccessPointType_update_column = AccessPointType_update_column = {}));
/** unique or primary key constraints on table "AccessPoint" */
var AccessPoint_constraint;
(function (AccessPoint_constraint) {
    /** unique or primary key constraint on columns "deprecatedAccessPointId" */
    AccessPoint_constraint["AccessPoint_deprecatedAccessPointId_key"] = "AccessPoint_deprecatedAccessPointId_key";
    /** unique or primary key constraint on columns "accessPointId" */
    AccessPoint_constraint["AccessPoint_pkey"] = "AccessPoint_pkey";
    /** unique or primary key constraint on columns "name", "propertyId" */
    AccessPoint_constraint["AccessPoint_propertyId_name_key"] = "AccessPoint_propertyId_name_key";
})(AccessPoint_constraint || (exports.AccessPoint_constraint = AccessPoint_constraint = {}));
/** select columns of table "AccessPoint" */
var AccessPoint_select_column;
(function (AccessPoint_select_column) {
    /** column name */
    AccessPoint_select_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPoint_select_column["accessTimeout"] = "accessTimeout";
    /** column name */
    AccessPoint_select_column["archivedAt"] = "archivedAt";
    /** column name */
    AccessPoint_select_column["archivedByUserId"] = "archivedByUserId";
    /** column name */
    AccessPoint_select_column["createdAt"] = "createdAt";
    /** column name */
    AccessPoint_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    AccessPoint_select_column["deprecatedAccessPointId"] = "deprecatedAccessPointId";
    /** column name */
    AccessPoint_select_column["dpsAlertDelay"] = "dpsAlertDelay";
    /** column name */
    AccessPoint_select_column["dpsAlertInterval"] = "dpsAlertInterval";
    /** column name */
    AccessPoint_select_column["imageId"] = "imageId";
    /** column name */
    AccessPoint_select_column["mapLocation"] = "mapLocation";
    /** column name */
    AccessPoint_select_column["maxOccupancy"] = "maxOccupancy";
    /** column name */
    AccessPoint_select_column["name"] = "name";
    /** column name */
    AccessPoint_select_column["propertyId"] = "propertyId";
    /** column name */
    AccessPoint_select_column["proximityRestriction"] = "proximityRestriction";
    /** column name */
    AccessPoint_select_column["spaceshipModeEnabled"] = "spaceshipModeEnabled";
    /** column name */
    AccessPoint_select_column["timetable"] = "timetable";
    /** column name */
    AccessPoint_select_column["type"] = "type";
    /** column name */
    AccessPoint_select_column["updatedAt"] = "updatedAt";
})(AccessPoint_select_column || (exports.AccessPoint_select_column = AccessPoint_select_column = {}));
/** select "AccessPoint_aggregate_bool_exp_bool_and_arguments_columns" columns of table "AccessPoint" */
var AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns;
(function (AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns["proximityRestriction"] = "proximityRestriction";
    /** column name */
    AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns["spaceshipModeEnabled"] = "spaceshipModeEnabled";
})(AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns || (exports.AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns = AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "AccessPoint_aggregate_bool_exp_bool_or_arguments_columns" columns of table "AccessPoint" */
var AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns;
(function (AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns["proximityRestriction"] = "proximityRestriction";
    /** column name */
    AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns["spaceshipModeEnabled"] = "spaceshipModeEnabled";
})(AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns || (exports.AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns = AccessPoint_select_column_AccessPoint_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "AccessPoint" */
var AccessPoint_update_column;
(function (AccessPoint_update_column) {
    /** column name */
    AccessPoint_update_column["accessPointId"] = "accessPointId";
    /** column name */
    AccessPoint_update_column["accessTimeout"] = "accessTimeout";
    /** column name */
    AccessPoint_update_column["archivedAt"] = "archivedAt";
    /** column name */
    AccessPoint_update_column["archivedByUserId"] = "archivedByUserId";
    /** column name */
    AccessPoint_update_column["createdAt"] = "createdAt";
    /** column name */
    AccessPoint_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    AccessPoint_update_column["deprecatedAccessPointId"] = "deprecatedAccessPointId";
    /** column name */
    AccessPoint_update_column["dpsAlertDelay"] = "dpsAlertDelay";
    /** column name */
    AccessPoint_update_column["dpsAlertInterval"] = "dpsAlertInterval";
    /** column name */
    AccessPoint_update_column["imageId"] = "imageId";
    /** column name */
    AccessPoint_update_column["mapLocation"] = "mapLocation";
    /** column name */
    AccessPoint_update_column["maxOccupancy"] = "maxOccupancy";
    /** column name */
    AccessPoint_update_column["name"] = "name";
    /** column name */
    AccessPoint_update_column["propertyId"] = "propertyId";
    /** column name */
    AccessPoint_update_column["proximityRestriction"] = "proximityRestriction";
    /** column name */
    AccessPoint_update_column["spaceshipModeEnabled"] = "spaceshipModeEnabled";
    /** column name */
    AccessPoint_update_column["timetable"] = "timetable";
    /** column name */
    AccessPoint_update_column["type"] = "type";
    /** column name */
    AccessPoint_update_column["updatedAt"] = "updatedAt";
})(AccessPoint_update_column || (exports.AccessPoint_update_column = AccessPoint_update_column = {}));
/** unique or primary key constraints on table "AccountStatus" */
var AccountStatus_constraint;
(function (AccountStatus_constraint) {
    /** unique or primary key constraint on columns "label" */
    AccountStatus_constraint["AccountStatus_label_key"] = "AccountStatus_label_key";
    /** unique or primary key constraint on columns "value" */
    AccountStatus_constraint["AccountStatus_pkey"] = "AccountStatus_pkey";
})(AccountStatus_constraint || (exports.AccountStatus_constraint = AccountStatus_constraint = {}));
var AccountStatus_enum;
(function (AccountStatus_enum) {
    /** Disabled */
    AccountStatus_enum["DISABLED"] = "DISABLED";
    /** Enabled */
    AccountStatus_enum["ENABLED"] = "ENABLED";
})(AccountStatus_enum || (exports.AccountStatus_enum = AccountStatus_enum = {}));
/** select columns of table "AccountStatus" */
var AccountStatus_select_column;
(function (AccountStatus_select_column) {
    /** column name */
    AccountStatus_select_column["label"] = "label";
    /** column name */
    AccountStatus_select_column["value"] = "value";
})(AccountStatus_select_column || (exports.AccountStatus_select_column = AccountStatus_select_column = {}));
/** update columns of table "AccountStatus" */
var AccountStatus_update_column;
(function (AccountStatus_update_column) {
    /** column name */
    AccountStatus_update_column["label"] = "label";
    /** column name */
    AccountStatus_update_column["value"] = "value";
})(AccountStatus_update_column || (exports.AccountStatus_update_column = AccountStatus_update_column = {}));
/** unique or primary key constraints on table "Announcement" */
var Announcement_constraint;
(function (Announcement_constraint) {
    /** unique or primary key constraint on columns "announcementId" */
    Announcement_constraint["Announcement_pkey"] = "Announcement_pkey";
})(Announcement_constraint || (exports.Announcement_constraint = Announcement_constraint = {}));
/** select columns of table "Announcement" */
var Announcement_select_column;
(function (Announcement_select_column) {
    /** column name */
    Announcement_select_column["announcementId"] = "announcementId";
    /** column name */
    Announcement_select_column["createdAt"] = "createdAt";
    /** column name */
    Announcement_select_column["message"] = "message";
    /** column name */
    Announcement_select_column["title"] = "title";
    /** column name */
    Announcement_select_column["updatedAt"] = "updatedAt";
})(Announcement_select_column || (exports.Announcement_select_column = Announcement_select_column = {}));
/** update columns of table "Announcement" */
var Announcement_update_column;
(function (Announcement_update_column) {
    /** column name */
    Announcement_update_column["announcementId"] = "announcementId";
    /** column name */
    Announcement_update_column["createdAt"] = "createdAt";
    /** column name */
    Announcement_update_column["message"] = "message";
    /** column name */
    Announcement_update_column["title"] = "title";
    /** column name */
    Announcement_update_column["updatedAt"] = "updatedAt";
})(Announcement_update_column || (exports.Announcement_update_column = Announcement_update_column = {}));
/** unique or primary key constraints on table "ApiKey" */
var ApiKey_constraint;
(function (ApiKey_constraint) {
    /** unique or primary key constraint on columns "apiKeyId" */
    ApiKey_constraint["ApiKey_pkey"] = "ApiKey_pkey";
    /** unique or primary key constraint on columns "publicKey" */
    ApiKey_constraint["ApiKey_publicKey_key"] = "ApiKey_publicKey_key";
})(ApiKey_constraint || (exports.ApiKey_constraint = ApiKey_constraint = {}));
/** select columns of table "ApiKey" */
var ApiKey_select_column;
(function (ApiKey_select_column) {
    /** column name */
    ApiKey_select_column["apiKeyId"] = "apiKeyId";
    /** column name */
    ApiKey_select_column["createdAt"] = "createdAt";
    /** column name */
    ApiKey_select_column["issuer"] = "issuer";
    /** column name */
    ApiKey_select_column["name"] = "name";
    /** column name */
    ApiKey_select_column["organizationId"] = "organizationId";
    /** column name */
    ApiKey_select_column["publicKey"] = "publicKey";
    /** column name */
    ApiKey_select_column["updatedAt"] = "updatedAt";
})(ApiKey_select_column || (exports.ApiKey_select_column = ApiKey_select_column = {}));
/** update columns of table "ApiKey" */
var ApiKey_update_column;
(function (ApiKey_update_column) {
    /** column name */
    ApiKey_update_column["apiKeyId"] = "apiKeyId";
    /** column name */
    ApiKey_update_column["createdAt"] = "createdAt";
    /** column name */
    ApiKey_update_column["issuer"] = "issuer";
    /** column name */
    ApiKey_update_column["name"] = "name";
    /** column name */
    ApiKey_update_column["organizationId"] = "organizationId";
    /** column name */
    ApiKey_update_column["publicKey"] = "publicKey";
    /** column name */
    ApiKey_update_column["updatedAt"] = "updatedAt";
})(ApiKey_update_column || (exports.ApiKey_update_column = ApiKey_update_column = {}));
var AugustRemoteOperation;
(function (AugustRemoteOperation) {
    AugustRemoteOperation["lock"] = "lock";
    AugustRemoteOperation["rebootLock"] = "rebootLock";
    AugustRemoteOperation["status"] = "status";
    AugustRemoteOperation["unlock"] = "unlock";
})(AugustRemoteOperation || (exports.AugustRemoteOperation = AugustRemoteOperation = {}));
/** unique or primary key constraints on table "AuthMethod" */
var AuthMethod_constraint;
(function (AuthMethod_constraint) {
    /** unique or primary key constraint on columns "label" */
    AuthMethod_constraint["AuthMethod_label_key"] = "AuthMethod_label_key";
    /** unique or primary key constraint on columns "value" */
    AuthMethod_constraint["AuthMethod_pkey"] = "AuthMethod_pkey";
})(AuthMethod_constraint || (exports.AuthMethod_constraint = AuthMethod_constraint = {}));
var AuthMethod_enum;
(function (AuthMethod_enum) {
    /** 2FA - August OAuth */
    AuthMethod_enum["AUGUST_OAUTH"] = "AUGUST_OAUTH";
    /** 1FA - Email */
    AuthMethod_enum["EMAIL"] = "EMAIL";
    /** 2FA - Email and Password */
    AuthMethod_enum["EMAIL_AND_PASSWORD"] = "EMAIL_AND_PASSWORD";
    /** 1FA - Phone Number */
    AuthMethod_enum["PHONE_NUMBER"] = "PHONE_NUMBER";
    /** 2FA - Phone Number and Email */
    AuthMethod_enum["PHONE_NUMBER_AND_EMAIL"] = "PHONE_NUMBER_AND_EMAIL";
    /** 2FA - Phone Number and Password */
    AuthMethod_enum["PHONE_NUMBER_AND_PASSWORD"] = "PHONE_NUMBER_AND_PASSWORD";
    /** Single Sign-On */
    AuthMethod_enum["SINGLE_SIGN_ON"] = "SINGLE_SIGN_ON";
})(AuthMethod_enum || (exports.AuthMethod_enum = AuthMethod_enum = {}));
/** select columns of table "AuthMethod" */
var AuthMethod_select_column;
(function (AuthMethod_select_column) {
    /** column name */
    AuthMethod_select_column["label"] = "label";
    /** column name */
    AuthMethod_select_column["value"] = "value";
})(AuthMethod_select_column || (exports.AuthMethod_select_column = AuthMethod_select_column = {}));
/** update columns of table "AuthMethod" */
var AuthMethod_update_column;
(function (AuthMethod_update_column) {
    /** column name */
    AuthMethod_update_column["label"] = "label";
    /** column name */
    AuthMethod_update_column["value"] = "value";
})(AuthMethod_update_column || (exports.AuthMethod_update_column = AuthMethod_update_column = {}));
/** unique or primary key constraints on table "BeaconPassword" */
var BeaconPassword_constraint;
(function (BeaconPassword_constraint) {
    /** unique or primary key constraint on columns "macAddress" */
    BeaconPassword_constraint["BeaconPassword_macAddress_key"] = "BeaconPassword_macAddress_key";
    /** unique or primary key constraint on columns "beaconPasswordId" */
    BeaconPassword_constraint["BeaconPassword_pkey"] = "BeaconPassword_pkey";
})(BeaconPassword_constraint || (exports.BeaconPassword_constraint = BeaconPassword_constraint = {}));
/** select columns of table "BeaconPassword" */
var BeaconPassword_select_column;
(function (BeaconPassword_select_column) {
    /** column name */
    BeaconPassword_select_column["beaconPasswordId"] = "beaconPasswordId";
    /** column name */
    BeaconPassword_select_column["createdAt"] = "createdAt";
    /** column name */
    BeaconPassword_select_column["currentPassword"] = "currentPassword";
    /** column name */
    BeaconPassword_select_column["desiredPassword"] = "desiredPassword";
    /** column name */
    BeaconPassword_select_column["macAddress"] = "macAddress";
    /** column name */
    BeaconPassword_select_column["rotatedAt"] = "rotatedAt";
    /** column name */
    BeaconPassword_select_column["updatedAt"] = "updatedAt";
})(BeaconPassword_select_column || (exports.BeaconPassword_select_column = BeaconPassword_select_column = {}));
/** update columns of table "BeaconPassword" */
var BeaconPassword_update_column;
(function (BeaconPassword_update_column) {
    /** column name */
    BeaconPassword_update_column["beaconPasswordId"] = "beaconPasswordId";
    /** column name */
    BeaconPassword_update_column["createdAt"] = "createdAt";
    /** column name */
    BeaconPassword_update_column["currentPassword"] = "currentPassword";
    /** column name */
    BeaconPassword_update_column["desiredPassword"] = "desiredPassword";
    /** column name */
    BeaconPassword_update_column["macAddress"] = "macAddress";
    /** column name */
    BeaconPassword_update_column["rotatedAt"] = "rotatedAt";
    /** column name */
    BeaconPassword_update_column["updatedAt"] = "updatedAt";
})(BeaconPassword_update_column || (exports.BeaconPassword_update_column = BeaconPassword_update_column = {}));
/** unique or primary key constraints on table "Beacon" */
var Beacon_constraint;
(function (Beacon_constraint) {
    /** unique or primary key constraint on columns "beaconId" */
    Beacon_constraint["Beacon_pkey"] = "Beacon_pkey";
})(Beacon_constraint || (exports.Beacon_constraint = Beacon_constraint = {}));
/** select columns of table "Beacon" */
var Beacon_select_column;
(function (Beacon_select_column) {
    /** column name */
    Beacon_select_column["accessPointId"] = "accessPointId";
    /** column name */
    Beacon_select_column["beaconId"] = "beaconId";
    /** column name */
    Beacon_select_column["createdAt"] = "createdAt";
    /** column name */
    Beacon_select_column["location"] = "location";
    /** column name */
    Beacon_select_column["macAddress"] = "macAddress";
    /** column name */
    Beacon_select_column["major"] = "major";
    /** column name */
    Beacon_select_column["minor"] = "minor";
    /** column name */
    Beacon_select_column["name"] = "name";
    /** column name */
    Beacon_select_column["updatedAt"] = "updatedAt";
    /** column name */
    Beacon_select_column["uuid"] = "uuid";
})(Beacon_select_column || (exports.Beacon_select_column = Beacon_select_column = {}));
/** update columns of table "Beacon" */
var Beacon_update_column;
(function (Beacon_update_column) {
    /** column name */
    Beacon_update_column["accessPointId"] = "accessPointId";
    /** column name */
    Beacon_update_column["beaconId"] = "beaconId";
    /** column name */
    Beacon_update_column["createdAt"] = "createdAt";
    /** column name */
    Beacon_update_column["location"] = "location";
    /** column name */
    Beacon_update_column["macAddress"] = "macAddress";
    /** column name */
    Beacon_update_column["major"] = "major";
    /** column name */
    Beacon_update_column["minor"] = "minor";
    /** column name */
    Beacon_update_column["name"] = "name";
    /** column name */
    Beacon_update_column["updatedAt"] = "updatedAt";
    /** column name */
    Beacon_update_column["uuid"] = "uuid";
})(Beacon_update_column || (exports.Beacon_update_column = Beacon_update_column = {}));
/** unique or primary key constraints on table "CredentialType" */
var CredentialType_constraint;
(function (CredentialType_constraint) {
    /** unique or primary key constraint on columns "label" */
    CredentialType_constraint["CredentialType_label_key"] = "CredentialType_label_key";
    /** unique or primary key constraint on columns "value" */
    CredentialType_constraint["CredentialType_pkey"] = "CredentialType_pkey";
})(CredentialType_constraint || (exports.CredentialType_constraint = CredentialType_constraint = {}));
var CredentialType_enum;
(function (CredentialType_enum) {
    /** Fob */
    CredentialType_enum["FOB"] = "FOB";
    /** Mobile */
    CredentialType_enum["MOBILE"] = "MOBILE";
})(CredentialType_enum || (exports.CredentialType_enum = CredentialType_enum = {}));
/** select columns of table "CredentialType" */
var CredentialType_select_column;
(function (CredentialType_select_column) {
    /** column name */
    CredentialType_select_column["label"] = "label";
    /** column name */
    CredentialType_select_column["value"] = "value";
})(CredentialType_select_column || (exports.CredentialType_select_column = CredentialType_select_column = {}));
/** update columns of table "CredentialType" */
var CredentialType_update_column;
(function (CredentialType_update_column) {
    /** column name */
    CredentialType_update_column["label"] = "label";
    /** column name */
    CredentialType_update_column["value"] = "value";
})(CredentialType_update_column || (exports.CredentialType_update_column = CredentialType_update_column = {}));
/** unique or primary key constraints on table "Credential" */
var Credential_constraint;
(function (Credential_constraint) {
    /** unique or primary key constraint on columns "identifier" */
    Credential_constraint["Credential_identifier_key"] = "Credential_identifier_key";
    /** unique or primary key constraint on columns "identifier", "ownedByPropertyId" */
    Credential_constraint["Credential_identifier_propertyId_key"] = "Credential_identifier_propertyId_key";
    /** unique or primary key constraint on columns "credentialId" */
    Credential_constraint["Credential_pkey"] = "Credential_pkey";
    /** unique or primary key constraint on columns "cardNumber", "facilityCode", "ownedByPropertyId" */
    Credential_constraint["Credential_propertyId_facilityCode_cardNumber_key"] = "Credential_propertyId_facilityCode_cardNumber_key";
})(Credential_constraint || (exports.Credential_constraint = Credential_constraint = {}));
/** select columns of table "Credential" */
var Credential_select_column;
(function (Credential_select_column) {
    /** column name */
    Credential_select_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    Credential_select_column["cardNumber"] = "cardNumber";
    /** column name */
    Credential_select_column["createdAt"] = "createdAt";
    /** column name */
    Credential_select_column["credentialId"] = "credentialId";
    /** column name */
    Credential_select_column["facilityCode"] = "facilityCode";
    /** column name */
    Credential_select_column["identifier"] = "identifier";
    /** column name */
    Credential_select_column["ownedByPropertyId"] = "ownedByPropertyId";
    /** column name */
    Credential_select_column["provisionedByUserId"] = "provisionedByUserId";
    /** column name */
    Credential_select_column["sourcePayload"] = "sourcePayload";
    /** column name */
    Credential_select_column["type"] = "type";
    /** column name */
    Credential_select_column["updatedAt"] = "updatedAt";
})(Credential_select_column || (exports.Credential_select_column = Credential_select_column = {}));
/** update columns of table "Credential" */
var Credential_update_column;
(function (Credential_update_column) {
    /** column name */
    Credential_update_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    Credential_update_column["cardNumber"] = "cardNumber";
    /** column name */
    Credential_update_column["createdAt"] = "createdAt";
    /** column name */
    Credential_update_column["credentialId"] = "credentialId";
    /** column name */
    Credential_update_column["facilityCode"] = "facilityCode";
    /** column name */
    Credential_update_column["identifier"] = "identifier";
    /** column name */
    Credential_update_column["ownedByPropertyId"] = "ownedByPropertyId";
    /** column name */
    Credential_update_column["provisionedByUserId"] = "provisionedByUserId";
    /** column name */
    Credential_update_column["sourcePayload"] = "sourcePayload";
    /** column name */
    Credential_update_column["type"] = "type";
    /** column name */
    Credential_update_column["updatedAt"] = "updatedAt";
})(Credential_update_column || (exports.Credential_update_column = Credential_update_column = {}));
var Custom_UnlockAccessPointResult;
(function (Custom_UnlockAccessPointResult) {
    Custom_UnlockAccessPointResult["SUCCESS"] = "SUCCESS";
    Custom_UnlockAccessPointResult["UNKNOWN"] = "UNKNOWN";
})(Custom_UnlockAccessPointResult || (exports.Custom_UnlockAccessPointResult = Custom_UnlockAccessPointResult = {}));
/** unique or primary key constraints on table "FailurePlan" */
var FailurePlan_constraint;
(function (FailurePlan_constraint) {
    /** unique or primary key constraint on columns "label" */
    FailurePlan_constraint["FailurePlan_label_key"] = "FailurePlan_label_key";
    /** unique or primary key constraint on columns "value" */
    FailurePlan_constraint["FailurePlan_pkey"] = "FailurePlan_pkey";
})(FailurePlan_constraint || (exports.FailurePlan_constraint = FailurePlan_constraint = {}));
var FailurePlan_enum;
(function (FailurePlan_enum) {
    /** Fail-Safe */
    FailurePlan_enum["FAIL_SAFE"] = "FAIL_SAFE";
    /** Fail-Secure */
    FailurePlan_enum["FAIL_SECURE"] = "FAIL_SECURE";
})(FailurePlan_enum || (exports.FailurePlan_enum = FailurePlan_enum = {}));
/** select columns of table "FailurePlan" */
var FailurePlan_select_column;
(function (FailurePlan_select_column) {
    /** column name */
    FailurePlan_select_column["label"] = "label";
    /** column name */
    FailurePlan_select_column["value"] = "value";
})(FailurePlan_select_column || (exports.FailurePlan_select_column = FailurePlan_select_column = {}));
/** update columns of table "FailurePlan" */
var FailurePlan_update_column;
(function (FailurePlan_update_column) {
    /** column name */
    FailurePlan_update_column["label"] = "label";
    /** column name */
    FailurePlan_update_column["value"] = "value";
})(FailurePlan_update_column || (exports.FailurePlan_update_column = FailurePlan_update_column = {}));
/** unique or primary key constraints on table "Favorite" */
var Favorite_constraint;
(function (Favorite_constraint) {
    /** unique or primary key constraint on columns "favoriteId" */
    Favorite_constraint["Favorite_pkey"] = "Favorite_pkey";
    /** unique or primary key constraint on columns "accessPointId", "userId" */
    Favorite_constraint["Favorite_userId_accessPointId_key"] = "Favorite_userId_accessPointId_key";
})(Favorite_constraint || (exports.Favorite_constraint = Favorite_constraint = {}));
/** select columns of table "Favorite" */
var Favorite_select_column;
(function (Favorite_select_column) {
    /** column name */
    Favorite_select_column["accessPointId"] = "accessPointId";
    /** column name */
    Favorite_select_column["createdAt"] = "createdAt";
    /** column name */
    Favorite_select_column["favoriteId"] = "favoriteId";
    /** column name */
    Favorite_select_column["position"] = "position";
    /** column name */
    Favorite_select_column["updatedAt"] = "updatedAt";
    /** column name */
    Favorite_select_column["userId"] = "userId";
})(Favorite_select_column || (exports.Favorite_select_column = Favorite_select_column = {}));
/** update columns of table "Favorite" */
var Favorite_update_column;
(function (Favorite_update_column) {
    /** column name */
    Favorite_update_column["accessPointId"] = "accessPointId";
    /** column name */
    Favorite_update_column["createdAt"] = "createdAt";
    /** column name */
    Favorite_update_column["favoriteId"] = "favoriteId";
    /** column name */
    Favorite_update_column["position"] = "position";
    /** column name */
    Favorite_update_column["updatedAt"] = "updatedAt";
    /** column name */
    Favorite_update_column["userId"] = "userId";
})(Favorite_update_column || (exports.Favorite_update_column = Favorite_update_column = {}));
/** unique or primary key constraints on table "FeatureFlagKey" */
var FeatureFlagKey_constraint;
(function (FeatureFlagKey_constraint) {
    /** unique or primary key constraint on columns "value" */
    FeatureFlagKey_constraint["FeatureFlagKey_pkey"] = "FeatureFlagKey_pkey";
})(FeatureFlagKey_constraint || (exports.FeatureFlagKey_constraint = FeatureFlagKey_constraint = {}));
var FeatureFlagKey_enum;
(function (FeatureFlagKey_enum) {
    FeatureFlagKey_enum["COMMUNITY_CONNECT"] = "COMMUNITY_CONNECT";
    FeatureFlagKey_enum["DPS"] = "DPS";
    FeatureFlagKey_enum["ENGRAIN_MAP_INTEGRATION"] = "ENGRAIN_MAP_INTEGRATION";
    FeatureFlagKey_enum["GATEWAY_ACCESS_MANAGER"] = "GATEWAY_ACCESS_MANAGER";
    FeatureFlagKey_enum["GATEWAY_MICROSERVICES"] = "GATEWAY_MICROSERVICES";
    FeatureFlagKey_enum["GATEWAY_MOBILE_ENHANCER"] = "GATEWAY_MOBILE_ENHANCER";
    FeatureFlagKey_enum["GATEWAY_PIN_CODES"] = "GATEWAY_PIN_CODES";
    FeatureFlagKey_enum["GATEWAY_UNLOCK_FEEDBACK"] = "GATEWAY_UNLOCK_FEEDBACK";
    FeatureFlagKey_enum["HOME_ACCESS"] = "HOME_ACCESS";
    FeatureFlagKey_enum["PMS_BACKBONE_RESIDENT_SYNC"] = "PMS_BACKBONE_RESIDENT_SYNC";
    FeatureFlagKey_enum["PMS_RESIDENT_SYNC"] = "PMS_RESIDENT_SYNC";
    FeatureFlagKey_enum["SMART_SIGNS"] = "SMART_SIGNS";
    FeatureFlagKey_enum["VENDOR_PASSCODES"] = "VENDOR_PASSCODES";
    FeatureFlagKey_enum["VIRTUAL_DIRECTORY"] = "VIRTUAL_DIRECTORY";
})(FeatureFlagKey_enum || (exports.FeatureFlagKey_enum = FeatureFlagKey_enum = {}));
/** select columns of table "FeatureFlagKey" */
var FeatureFlagKey_select_column;
(function (FeatureFlagKey_select_column) {
    /** column name */
    FeatureFlagKey_select_column["value"] = "value";
})(FeatureFlagKey_select_column || (exports.FeatureFlagKey_select_column = FeatureFlagKey_select_column = {}));
/** update columns of table "FeatureFlagKey" */
var FeatureFlagKey_update_column;
(function (FeatureFlagKey_update_column) {
    /** column name */
    FeatureFlagKey_update_column["value"] = "value";
})(FeatureFlagKey_update_column || (exports.FeatureFlagKey_update_column = FeatureFlagKey_update_column = {}));
/** unique or primary key constraints on table "FeatureFlag" */
var FeatureFlag_constraint;
(function (FeatureFlag_constraint) {
    /** unique or primary key constraint on columns "key" */
    FeatureFlag_constraint["FeatureFlag_key_key"] = "FeatureFlag_key_key";
    /** unique or primary key constraint on columns "name" */
    FeatureFlag_constraint["FeatureFlag_key_name"] = "FeatureFlag_key_name";
    /** unique or primary key constraint on columns "featureFlagId" */
    FeatureFlag_constraint["FeatureFlag_pkey"] = "FeatureFlag_pkey";
})(FeatureFlag_constraint || (exports.FeatureFlag_constraint = FeatureFlag_constraint = {}));
/** select columns of table "FeatureFlag" */
var FeatureFlag_select_column;
(function (FeatureFlag_select_column) {
    /** column name */
    FeatureFlag_select_column["createdAt"] = "createdAt";
    /** column name */
    FeatureFlag_select_column["description"] = "description";
    /** column name */
    FeatureFlag_select_column["featureFlagId"] = "featureFlagId";
    /** column name */
    FeatureFlag_select_column["isLocked"] = "isLocked";
    /** column name */
    FeatureFlag_select_column["key"] = "key";
    /** column name */
    FeatureFlag_select_column["name"] = "name";
    /** column name */
    FeatureFlag_select_column["updatedAt"] = "updatedAt";
})(FeatureFlag_select_column || (exports.FeatureFlag_select_column = FeatureFlag_select_column = {}));
/** update columns of table "FeatureFlag" */
var FeatureFlag_update_column;
(function (FeatureFlag_update_column) {
    /** column name */
    FeatureFlag_update_column["createdAt"] = "createdAt";
    /** column name */
    FeatureFlag_update_column["description"] = "description";
    /** column name */
    FeatureFlag_update_column["featureFlagId"] = "featureFlagId";
    /** column name */
    FeatureFlag_update_column["isLocked"] = "isLocked";
    /** column name */
    FeatureFlag_update_column["key"] = "key";
    /** column name */
    FeatureFlag_update_column["name"] = "name";
    /** column name */
    FeatureFlag_update_column["updatedAt"] = "updatedAt";
})(FeatureFlag_update_column || (exports.FeatureFlag_update_column = FeatureFlag_update_column = {}));
/** unique or primary key constraints on table "GpioMode" */
var GpioMode_constraint;
(function (GpioMode_constraint) {
    /** unique or primary key constraint on columns "label" */
    GpioMode_constraint["GpioMode_label_key"] = "GpioMode_label_key";
    /** unique or primary key constraint on columns "value" */
    GpioMode_constraint["GpioMode_pkey"] = "GpioMode_pkey";
})(GpioMode_constraint || (exports.GpioMode_constraint = GpioMode_constraint = {}));
var GpioMode_enum;
(function (GpioMode_enum) {
    /** Input */
    GpioMode_enum["INPUT"] = "INPUT";
    /** Output */
    GpioMode_enum["OUTPUT"] = "OUTPUT";
})(GpioMode_enum || (exports.GpioMode_enum = GpioMode_enum = {}));
/** select columns of table "GpioMode" */
var GpioMode_select_column;
(function (GpioMode_select_column) {
    /** column name */
    GpioMode_select_column["label"] = "label";
    /** column name */
    GpioMode_select_column["value"] = "value";
})(GpioMode_select_column || (exports.GpioMode_select_column = GpioMode_select_column = {}));
/** update columns of table "GpioMode" */
var GpioMode_update_column;
(function (GpioMode_update_column) {
    /** column name */
    GpioMode_update_column["label"] = "label";
    /** column name */
    GpioMode_update_column["value"] = "value";
})(GpioMode_update_column || (exports.GpioMode_update_column = GpioMode_update_column = {}));
/** unique or primary key constraints on table "HubActivationStatus" */
var HubActivationStatus_constraint;
(function (HubActivationStatus_constraint) {
    /** unique or primary key constraint on columns "label" */
    HubActivationStatus_constraint["HubActivationStatus_label_key"] = "HubActivationStatus_label_key";
    /** unique or primary key constraint on columns "value" */
    HubActivationStatus_constraint["HubActivationStatus_pkey"] = "HubActivationStatus_pkey";
})(HubActivationStatus_constraint || (exports.HubActivationStatus_constraint = HubActivationStatus_constraint = {}));
var HubActivationStatus_enum;
(function (HubActivationStatus_enum) {
    /** Activated */
    HubActivationStatus_enum["ACTIVATED"] = "ACTIVATED";
    /** Deactivated */
    HubActivationStatus_enum["DEACTIVATED"] = "DEACTIVATED";
    /** Pending Activation */
    HubActivationStatus_enum["PENDING_ACTIVATION"] = "PENDING_ACTIVATION";
})(HubActivationStatus_enum || (exports.HubActivationStatus_enum = HubActivationStatus_enum = {}));
/** select columns of table "HubActivationStatus" */
var HubActivationStatus_select_column;
(function (HubActivationStatus_select_column) {
    /** column name */
    HubActivationStatus_select_column["label"] = "label";
    /** column name */
    HubActivationStatus_select_column["value"] = "value";
})(HubActivationStatus_select_column || (exports.HubActivationStatus_select_column = HubActivationStatus_select_column = {}));
/** update columns of table "HubActivationStatus" */
var HubActivationStatus_update_column;
(function (HubActivationStatus_update_column) {
    /** column name */
    HubActivationStatus_update_column["label"] = "label";
    /** column name */
    HubActivationStatus_update_column["value"] = "value";
})(HubActivationStatus_update_column || (exports.HubActivationStatus_update_column = HubActivationStatus_update_column = {}));
/** unique or primary key constraints on table "HubDeviceType" */
var HubDeviceType_constraint;
(function (HubDeviceType_constraint) {
    /** unique or primary key constraint on columns "label" */
    HubDeviceType_constraint["HubDeviceType_label_key"] = "HubDeviceType_label_key";
    /** unique or primary key constraint on columns "value" */
    HubDeviceType_constraint["HubDeviceType_pkey"] = "HubDeviceType_pkey";
})(HubDeviceType_constraint || (exports.HubDeviceType_constraint = HubDeviceType_constraint = {}));
var HubDeviceType_enum;
(function (HubDeviceType_enum) {
    /** Ethos Edge Reader */
    HubDeviceType_enum["ETHOS_EDGE_READER"] = "ETHOS_EDGE_READER";
    /** Ethos Edge Reader N/C */
    HubDeviceType_enum["ETHOS_EDGE_READER_NC"] = "ETHOS_EDGE_READER_NC";
    /** Ethos Edge Reader N/O */
    HubDeviceType_enum["ETHOS_EDGE_READER_NO"] = "ETHOS_EDGE_READER_NO";
    /** Ethos Secure-Side Device */
    HubDeviceType_enum["ETHOS_SECURE_SIDE_DEVICE"] = "ETHOS_SECURE_SIDE_DEVICE";
    /** Ethos Secure-Side Device N/C */
    HubDeviceType_enum["ETHOS_SECURE_SIDE_DEVICE_NC"] = "ETHOS_SECURE_SIDE_DEVICE_NC";
    /** Ethos Secure-Side Device N/O */
    HubDeviceType_enum["ETHOS_SECURE_SIDE_DEVICE_NO"] = "ETHOS_SECURE_SIDE_DEVICE_NO";
    /** Raspberry Pi */
    HubDeviceType_enum["RASPBERRY_PI"] = "RASPBERRY_PI";
})(HubDeviceType_enum || (exports.HubDeviceType_enum = HubDeviceType_enum = {}));
/** select columns of table "HubDeviceType" */
var HubDeviceType_select_column;
(function (HubDeviceType_select_column) {
    /** column name */
    HubDeviceType_select_column["label"] = "label";
    /** column name */
    HubDeviceType_select_column["value"] = "value";
})(HubDeviceType_select_column || (exports.HubDeviceType_select_column = HubDeviceType_select_column = {}));
/** update columns of table "HubDeviceType" */
var HubDeviceType_update_column;
(function (HubDeviceType_update_column) {
    /** column name */
    HubDeviceType_update_column["label"] = "label";
    /** column name */
    HubDeviceType_update_column["value"] = "value";
})(HubDeviceType_update_column || (exports.HubDeviceType_update_column = HubDeviceType_update_column = {}));
/** unique or primary key constraints on table "Hub" */
var Hub_constraint;
(function (Hub_constraint) {
    /** unique or primary key constraint on columns "fingerprint" */
    Hub_constraint["Hub_fingerprint_key"] = "Hub_fingerprint_key";
    /** unique or primary key constraint on columns "port", "host" */
    Hub_constraint["Hub_host_port_key"] = "Hub_host_port_key";
    /** unique or primary key constraint on columns "hubId" */
    Hub_constraint["Hub_pkey"] = "Hub_pkey";
})(Hub_constraint || (exports.Hub_constraint = Hub_constraint = {}));
/** select columns of table "Hub" */
var Hub_select_column;
(function (Hub_select_column) {
    /** column name */
    Hub_select_column["activationStatus"] = "activationStatus";
    /** column name */
    Hub_select_column["channels"] = "channels";
    /** column name */
    Hub_select_column["cliVersion"] = "cliVersion";
    /** column name */
    Hub_select_column["createdAt"] = "createdAt";
    /** column name */
    Hub_select_column["deviceType"] = "deviceType";
    /** column name */
    Hub_select_column["fingerprint"] = "fingerprint";
    /** column name */
    Hub_select_column["firmwareVersion"] = "firmwareVersion";
    /** column name */
    Hub_select_column["host"] = "host";
    /** column name */
    Hub_select_column["hubId"] = "hubId";
    /** column name */
    Hub_select_column["hubVersion"] = "hubVersion";
    /** column name */
    Hub_select_column["installedAt"] = "installedAt";
    /** column name */
    Hub_select_column["ipAddress"] = "ipAddress";
    /** column name */
    Hub_select_column["location"] = "location";
    /** column name */
    Hub_select_column["macAddress"] = "macAddress";
    /** column name */
    Hub_select_column["name"] = "name";
    /** column name */
    Hub_select_column["parentHubId"] = "parentHubId";
    /** column name */
    Hub_select_column["port"] = "port";
    /** column name */
    Hub_select_column["propertyId"] = "propertyId";
    /** column name */
    Hub_select_column["updatedAt"] = "updatedAt";
})(Hub_select_column || (exports.Hub_select_column = Hub_select_column = {}));
/** update columns of table "Hub" */
var Hub_update_column;
(function (Hub_update_column) {
    /** column name */
    Hub_update_column["activationStatus"] = "activationStatus";
    /** column name */
    Hub_update_column["channels"] = "channels";
    /** column name */
    Hub_update_column["cliVersion"] = "cliVersion";
    /** column name */
    Hub_update_column["createdAt"] = "createdAt";
    /** column name */
    Hub_update_column["deviceType"] = "deviceType";
    /** column name */
    Hub_update_column["fingerprint"] = "fingerprint";
    /** column name */
    Hub_update_column["firmwareVersion"] = "firmwareVersion";
    /** column name */
    Hub_update_column["host"] = "host";
    /** column name */
    Hub_update_column["hubId"] = "hubId";
    /** column name */
    Hub_update_column["hubVersion"] = "hubVersion";
    /** column name */
    Hub_update_column["installedAt"] = "installedAt";
    /** column name */
    Hub_update_column["ipAddress"] = "ipAddress";
    /** column name */
    Hub_update_column["location"] = "location";
    /** column name */
    Hub_update_column["macAddress"] = "macAddress";
    /** column name */
    Hub_update_column["name"] = "name";
    /** column name */
    Hub_update_column["parentHubId"] = "parentHubId";
    /** column name */
    Hub_update_column["port"] = "port";
    /** column name */
    Hub_update_column["propertyId"] = "propertyId";
    /** column name */
    Hub_update_column["updatedAt"] = "updatedAt";
})(Hub_update_column || (exports.Hub_update_column = Hub_update_column = {}));
/** unique or primary key constraints on table "Image" */
var Image_constraint;
(function (Image_constraint) {
    /** unique or primary key constraint on columns "cloudId" */
    Image_constraint["Image_cloudId_key"] = "Image_cloudId_key";
    /** unique or primary key constraint on columns "imageId" */
    Image_constraint["Image_pkey"] = "Image_pkey";
})(Image_constraint || (exports.Image_constraint = Image_constraint = {}));
/** select columns of table "Image" */
var Image_select_column;
(function (Image_select_column) {
    /** column name */
    Image_select_column["cloudId"] = "cloudId";
    /** column name */
    Image_select_column["createdAt"] = "createdAt";
    /** column name */
    Image_select_column["imageId"] = "imageId";
    /** column name */
    Image_select_column["updatedAt"] = "updatedAt";
    /** column name */
    Image_select_column["uploadedByUserId"] = "uploadedByUserId";
})(Image_select_column || (exports.Image_select_column = Image_select_column = {}));
/** update columns of table "Image" */
var Image_update_column;
(function (Image_update_column) {
    /** column name */
    Image_update_column["cloudId"] = "cloudId";
    /** column name */
    Image_update_column["createdAt"] = "createdAt";
    /** column name */
    Image_update_column["imageId"] = "imageId";
    /** column name */
    Image_update_column["updatedAt"] = "updatedAt";
    /** column name */
    Image_update_column["uploadedByUserId"] = "uploadedByUserId";
})(Image_update_column || (exports.Image_update_column = Image_update_column = {}));
/** unique or primary key constraints on table "InputDevice" */
var InputDevice_constraint;
(function (InputDevice_constraint) {
    /** unique or primary key constraint on columns "label" */
    InputDevice_constraint["InputDevice_label_key"] = "InputDevice_label_key";
    /** unique or primary key constraint on columns "value" */
    InputDevice_constraint["InputDevice_pkey"] = "InputDevice_pkey";
})(InputDevice_constraint || (exports.InputDevice_constraint = InputDevice_constraint = {}));
var InputDevice_enum;
(function (InputDevice_enum) {
    /** Amazon Key */
    InputDevice_enum["AMAZON_KEY"] = "AMAZON_KEY";
    /** Door Position Sensor (DPS) */
    InputDevice_enum["DPS"] = "DPS";
    /** Intercom */
    InputDevice_enum["INTERCOM"] = "INTERCOM";
    /** Other */
    InputDevice_enum["OTHER"] = "OTHER";
    /** Request-to-Exit (REX) */
    InputDevice_enum["REX"] = "REX";
})(InputDevice_enum || (exports.InputDevice_enum = InputDevice_enum = {}));
/** select columns of table "InputDevice" */
var InputDevice_select_column;
(function (InputDevice_select_column) {
    /** column name */
    InputDevice_select_column["label"] = "label";
    /** column name */
    InputDevice_select_column["value"] = "value";
})(InputDevice_select_column || (exports.InputDevice_select_column = InputDevice_select_column = {}));
/** update columns of table "InputDevice" */
var InputDevice_update_column;
(function (InputDevice_update_column) {
    /** column name */
    InputDevice_update_column["label"] = "label";
    /** column name */
    InputDevice_update_column["value"] = "value";
})(InputDevice_update_column || (exports.InputDevice_update_column = InputDevice_update_column = {}));
/** unique or primary key constraints on table "Organization" */
var Organization_constraint;
(function (Organization_constraint) {
    /** unique or primary key constraint on columns "identifier" */
    Organization_constraint["Organization_identifier_key"] = "Organization_identifier_key";
    /** unique or primary key constraint on columns "organizationId" */
    Organization_constraint["Organization_pkey"] = "Organization_pkey";
})(Organization_constraint || (exports.Organization_constraint = Organization_constraint = {}));
/** select columns of table "Organization" */
var Organization_select_column;
(function (Organization_select_column) {
    /** column name */
    Organization_select_column["createdAt"] = "createdAt";
    /** column name */
    Organization_select_column["identifier"] = "identifier";
    /** column name */
    Organization_select_column["name"] = "name";
    /** column name */
    Organization_select_column["organizationId"] = "organizationId";
    /** column name */
    Organization_select_column["updatedAt"] = "updatedAt";
})(Organization_select_column || (exports.Organization_select_column = Organization_select_column = {}));
/** update columns of table "Organization" */
var Organization_update_column;
(function (Organization_update_column) {
    /** column name */
    Organization_update_column["createdAt"] = "createdAt";
    /** column name */
    Organization_update_column["identifier"] = "identifier";
    /** column name */
    Organization_update_column["name"] = "name";
    /** column name */
    Organization_update_column["organizationId"] = "organizationId";
    /** column name */
    Organization_update_column["updatedAt"] = "updatedAt";
})(Organization_update_column || (exports.Organization_update_column = Organization_update_column = {}));
/** select columns of table "PasswordRedacted" */
var PasswordRedacted_select_column;
(function (PasswordRedacted_select_column) {
    /** column name */
    PasswordRedacted_select_column["createdAt"] = "createdAt";
    /** column name */
    PasswordRedacted_select_column["passwordId"] = "passwordId";
    /** column name */
    PasswordRedacted_select_column["updatedAt"] = "updatedAt";
    /** column name */
    PasswordRedacted_select_column["userId"] = "userId";
})(PasswordRedacted_select_column || (exports.PasswordRedacted_select_column = PasswordRedacted_select_column = {}));
/** unique or primary key constraints on table "PermissionKey" */
var PermissionKey_constraint;
(function (PermissionKey_constraint) {
    /** unique or primary key constraint on columns "value" */
    PermissionKey_constraint["PermissionKey_pkey"] = "PermissionKey_pkey";
})(PermissionKey_constraint || (exports.PermissionKey_constraint = PermissionKey_constraint = {}));
var PermissionKey_enum;
(function (PermissionKey_enum) {
    PermissionKey_enum["AccessPoint_Archive"] = "AccessPoint_Archive";
    PermissionKey_enum["AccessPoint_BypassReservationOnly"] = "AccessPoint_BypassReservationOnly";
    PermissionKey_enum["AccessPoint_BypassSchedule"] = "AccessPoint_BypassSchedule";
    PermissionKey_enum["AccessPoint_Create"] = "AccessPoint_Create";
    PermissionKey_enum["AccessPoint_Delete"] = "AccessPoint_Delete";
    PermissionKey_enum["AccessPoint_ManageRelays"] = "AccessPoint_ManageRelays";
    PermissionKey_enum["AccessPoint_Read"] = "AccessPoint_Read";
    PermissionKey_enum["AccessPoint_StaffAccess"] = "AccessPoint_StaffAccess";
    PermissionKey_enum["AccessPoint_Unlock"] = "AccessPoint_Unlock";
    PermissionKey_enum["AccessPoint_Update"] = "AccessPoint_Update";
    PermissionKey_enum["Beacon_Create"] = "Beacon_Create";
    PermissionKey_enum["Beacon_Delete"] = "Beacon_Delete";
    PermissionKey_enum["Beacon_Read"] = "Beacon_Read";
    PermissionKey_enum["Beacon_Update"] = "Beacon_Update";
    PermissionKey_enum["Credential_Create"] = "Credential_Create";
    PermissionKey_enum["Credential_Delete"] = "Credential_Delete";
    PermissionKey_enum["Credential_Read"] = "Credential_Read";
    PermissionKey_enum["Credential_Update"] = "Credential_Update";
    PermissionKey_enum["Hub_Installation"] = "Hub_Installation";
    PermissionKey_enum["Hub_ManageReaders"] = "Hub_ManageReaders";
    PermissionKey_enum["Hub_Messenger"] = "Hub_Messenger";
    PermissionKey_enum["Hub_Read"] = "Hub_Read";
    PermissionKey_enum["Hub_Restart"] = "Hub_Restart";
    PermissionKey_enum["Hub_Update"] = "Hub_Update";
    PermissionKey_enum["Organization_Create"] = "Organization_Create";
    PermissionKey_enum["Organization_Update"] = "Organization_Update";
    PermissionKey_enum["PinCodePrivate_Read"] = "PinCodePrivate_Read";
    PermissionKey_enum["PinCode_AutoReceive"] = "PinCode_AutoReceive";
    PermissionKey_enum["PinCode_Create"] = "PinCode_Create";
    PermissionKey_enum["PinCode_Delete"] = "PinCode_Delete";
    PermissionKey_enum["PinCode_GenerateRandomByProperty"] = "PinCode_GenerateRandomByProperty";
    PermissionKey_enum["PinCode_GenerateRandomByUser"] = "PinCode_GenerateRandomByUser";
    PermissionKey_enum["PinCode_Read"] = "PinCode_Read";
    PermissionKey_enum["PinCode_Update"] = "PinCode_Update";
    PermissionKey_enum["Property_Create"] = "Property_Create";
    PermissionKey_enum["Property_Delete"] = "Property_Delete";
    PermissionKey_enum["Property_ManageFeatureFlags"] = "Property_ManageFeatureFlags";
    PermissionKey_enum["Property_ManageMaps"] = "Property_ManageMaps";
    PermissionKey_enum["Property_PmsResidentAudit"] = "Property_PmsResidentAudit";
    PermissionKey_enum["Property_PmsResidentSync"] = "Property_PmsResidentSync";
    PermissionKey_enum["Property_PmsUnitSync"] = "Property_PmsUnitSync";
    PermissionKey_enum["Property_Update"] = "Property_Update";
    PermissionKey_enum["RelayLogPrivate_Read"] = "RelayLogPrivate_Read";
    PermissionKey_enum["RelayLog_Read"] = "RelayLog_Read";
    PermissionKey_enum["Relay_Create"] = "Relay_Create";
    PermissionKey_enum["Relay_Delete"] = "Relay_Delete";
    PermissionKey_enum["Relay_Read"] = "Relay_Read";
    PermissionKey_enum["Relay_Update"] = "Relay_Update";
    PermissionKey_enum["Role_Create"] = "Role_Create";
    PermissionKey_enum["Role_Delete"] = "Role_Delete";
    PermissionKey_enum["Role_ManagePermissions"] = "Role_ManagePermissions";
    PermissionKey_enum["Role_ManageUnrestricted"] = "Role_ManageUnrestricted";
    PermissionKey_enum["Role_Read"] = "Role_Read";
    PermissionKey_enum["Role_Update"] = "Role_Update";
    PermissionKey_enum["Session_AccessApp"] = "Session_AccessApp";
    PermissionKey_enum["Session_AdminPanel"] = "Session_AdminPanel";
    PermissionKey_enum["Session_Read"] = "Session_Read";
    PermissionKey_enum["Session_Revoke"] = "Session_Revoke";
    PermissionKey_enum["SmartLockLog_Read"] = "SmartLockLog_Read";
    PermissionKey_enum["SmartLock_AugustSdkFeesReport"] = "SmartLock_AugustSdkFeesReport";
    PermissionKey_enum["SmartLock_AutoReceivePinCode"] = "SmartLock_AutoReceivePinCode";
    PermissionKey_enum["SmartLock_Create"] = "SmartLock_Create";
    PermissionKey_enum["SmartLock_Delete"] = "SmartLock_Delete";
    PermissionKey_enum["SmartLock_FactoryReset"] = "SmartLock_FactoryReset";
    PermissionKey_enum["SmartLock_ManagePinCodes"] = "SmartLock_ManagePinCodes";
    PermissionKey_enum["SmartLock_PropertyReport"] = "SmartLock_PropertyReport";
    PermissionKey_enum["SmartLock_Read"] = "SmartLock_Read";
    PermissionKey_enum["SmartLock_Unlock"] = "SmartLock_Unlock";
    PermissionKey_enum["SmartLock_Update"] = "SmartLock_Update";
    PermissionKey_enum["Ticket_Create"] = "Ticket_Create";
    PermissionKey_enum["Ticket_Delete"] = "Ticket_Delete";
    PermissionKey_enum["Ticket_Read"] = "Ticket_Read";
    PermissionKey_enum["Ticket_Update"] = "Ticket_Update";
    PermissionKey_enum["UnitGroup_Create"] = "UnitGroup_Create";
    PermissionKey_enum["UnitGroup_Delete"] = "UnitGroup_Delete";
    PermissionKey_enum["UnitGroup_Update"] = "UnitGroup_Update";
    PermissionKey_enum["Unit_Create"] = "Unit_Create";
    PermissionKey_enum["Unit_Delete"] = "Unit_Delete";
    PermissionKey_enum["Unit_PmsResidentAudit"] = "Unit_PmsResidentAudit";
    PermissionKey_enum["Unit_PmsResidentSync"] = "Unit_PmsResidentSync";
    PermissionKey_enum["Unit_Read"] = "Unit_Read";
    PermissionKey_enum["Unit_Update"] = "Unit_Update";
    PermissionKey_enum["UserRole_GrantRevokeGlobal"] = "UserRole_GrantRevokeGlobal";
    PermissionKey_enum["UserRole_GrantRevokeScoped"] = "UserRole_GrantRevokeScoped";
    PermissionKey_enum["UserRole_GrantVacantUnitsOnly"] = "UserRole_GrantVacantUnitsOnly";
    PermissionKey_enum["UserRole_SgtFunnelIntegration"] = "UserRole_SgtFunnelIntegration";
    PermissionKey_enum["UserRole_Update"] = "UserRole_Update";
    PermissionKey_enum["User_Create"] = "User_Create";
    PermissionKey_enum["User_Metrics"] = "User_Metrics";
    PermissionKey_enum["User_Read"] = "User_Read";
    PermissionKey_enum["User_SendMessage"] = "User_SendMessage";
    PermissionKey_enum["User_UpdateAccountStatus"] = "User_UpdateAccountStatus";
    PermissionKey_enum["User_UpdateProfile"] = "User_UpdateProfile";
    PermissionKey_enum["VendorPasscode_Read"] = "VendorPasscode_Read";
    PermissionKey_enum["VendorPasscode_ReadCode"] = "VendorPasscode_ReadCode";
    PermissionKey_enum["VendorPasscode_Regenerate"] = "VendorPasscode_Regenerate";
})(PermissionKey_enum || (exports.PermissionKey_enum = PermissionKey_enum = {}));
/** select columns of table "PermissionKey" */
var PermissionKey_select_column;
(function (PermissionKey_select_column) {
    /** column name */
    PermissionKey_select_column["value"] = "value";
})(PermissionKey_select_column || (exports.PermissionKey_select_column = PermissionKey_select_column = {}));
/** update columns of table "PermissionKey" */
var PermissionKey_update_column;
(function (PermissionKey_update_column) {
    /** column name */
    PermissionKey_update_column["value"] = "value";
})(PermissionKey_update_column || (exports.PermissionKey_update_column = PermissionKey_update_column = {}));
/** unique or primary key constraints on table "PermissionScope" */
var PermissionScope_constraint;
(function (PermissionScope_constraint) {
    /** unique or primary key constraint on columns "label" */
    PermissionScope_constraint["PermissionScope_label_key"] = "PermissionScope_label_key";
    /** unique or primary key constraint on columns "value" */
    PermissionScope_constraint["PermissionScope_pkey"] = "PermissionScope_pkey";
})(PermissionScope_constraint || (exports.PermissionScope_constraint = PermissionScope_constraint = {}));
var PermissionScope_enum;
(function (PermissionScope_enum) {
    /** Access Point */
    PermissionScope_enum["ACCESS_POINT"] = "ACCESS_POINT";
    /** Global */
    PermissionScope_enum["GLOBAL"] = "GLOBAL";
    /** Organization */
    PermissionScope_enum["ORGANIZATION"] = "ORGANIZATION";
    /** Property */
    PermissionScope_enum["PROPERTY"] = "PROPERTY";
    /** Smart Lock */
    PermissionScope_enum["SMART_LOCK"] = "SMART_LOCK";
    /** Unit */
    PermissionScope_enum["UNIT"] = "UNIT";
})(PermissionScope_enum || (exports.PermissionScope_enum = PermissionScope_enum = {}));
/** select columns of table "PermissionScope" */
var PermissionScope_select_column;
(function (PermissionScope_select_column) {
    /** column name */
    PermissionScope_select_column["label"] = "label";
    /** column name */
    PermissionScope_select_column["value"] = "value";
})(PermissionScope_select_column || (exports.PermissionScope_select_column = PermissionScope_select_column = {}));
/** update columns of table "PermissionScope" */
var PermissionScope_update_column;
(function (PermissionScope_update_column) {
    /** column name */
    PermissionScope_update_column["label"] = "label";
    /** column name */
    PermissionScope_update_column["value"] = "value";
})(PermissionScope_update_column || (exports.PermissionScope_update_column = PermissionScope_update_column = {}));
/** unique or primary key constraints on table "Permission" */
var Permission_constraint;
(function (Permission_constraint) {
    /** unique or primary key constraint on columns "key", "scope" */
    Permission_constraint["Permission_key_scope_key"] = "Permission_key_scope_key";
    /** unique or primary key constraint on columns "permissionId" */
    Permission_constraint["Permission_pkey"] = "Permission_pkey";
})(Permission_constraint || (exports.Permission_constraint = Permission_constraint = {}));
/** select columns of table "Permission" */
var Permission_select_column;
(function (Permission_select_column) {
    /** column name */
    Permission_select_column["createdAt"] = "createdAt";
    /** column name */
    Permission_select_column["isLocked"] = "isLocked";
    /** column name */
    Permission_select_column["key"] = "key";
    /** column name */
    Permission_select_column["permissionId"] = "permissionId";
    /** column name */
    Permission_select_column["scope"] = "scope";
    /** column name */
    Permission_select_column["updatedAt"] = "updatedAt";
})(Permission_select_column || (exports.Permission_select_column = Permission_select_column = {}));
/** select "Permission_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Permission" */
var Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns;
(function (Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns["isLocked"] = "isLocked";
})(Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns || (exports.Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns = Permission_select_column_Permission_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "Permission_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Permission" */
var Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns;
(function (Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns["isLocked"] = "isLocked";
})(Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns || (exports.Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns = Permission_select_column_Permission_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "Permission" */
var Permission_update_column;
(function (Permission_update_column) {
    /** column name */
    Permission_update_column["createdAt"] = "createdAt";
    /** column name */
    Permission_update_column["isLocked"] = "isLocked";
    /** column name */
    Permission_update_column["key"] = "key";
    /** column name */
    Permission_update_column["permissionId"] = "permissionId";
    /** column name */
    Permission_update_column["scope"] = "scope";
    /** column name */
    Permission_update_column["updatedAt"] = "updatedAt";
})(Permission_update_column || (exports.Permission_update_column = Permission_update_column = {}));
/** select columns of table "PinCodePrivate" */
var PinCodePrivate_select_column;
(function (PinCodePrivate_select_column) {
    /** column name */
    PinCodePrivate_select_column["code"] = "code";
    /** column name */
    PinCodePrivate_select_column["pinCodeId"] = "pinCodeId";
})(PinCodePrivate_select_column || (exports.PinCodePrivate_select_column = PinCodePrivate_select_column = {}));
/** unique or primary key constraints on table "PinCode" */
var PinCode_constraint;
(function (PinCode_constraint) {
    /** unique or primary key constraint on columns "assignedToUserId", "propertyId" */
    PinCode_constraint["PinCode_assignedToUserId_propertyId_key"] = "PinCode_assignedToUserId_propertyId_key";
    /** unique or primary key constraint on columns "pinCodeId" */
    PinCode_constraint["PinCode_pkey"] = "PinCode_pkey";
    /** unique or primary key constraint on columns "code", "propertyId" */
    PinCode_constraint["PinCode_propertyId_code_key"] = "PinCode_propertyId_code_key";
    /** unique or primary key constraint on columns "userRoleId" */
    PinCode_constraint["PinCode_userRoleId_key"] = "PinCode_userRoleId_key";
})(PinCode_constraint || (exports.PinCode_constraint = PinCode_constraint = {}));
/** select columns of table "PinCode" */
var PinCode_select_column;
(function (PinCode_select_column) {
    /** column name */
    PinCode_select_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    PinCode_select_column["code"] = "code";
    /** column name */
    PinCode_select_column["createdAt"] = "createdAt";
    /** column name */
    PinCode_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    PinCode_select_column["pinCodeId"] = "pinCodeId";
    /** column name */
    PinCode_select_column["propertyId"] = "propertyId";
    /** column name */
    PinCode_select_column["sourcePayload"] = "sourcePayload";
    /** column name */
    PinCode_select_column["updatedAt"] = "updatedAt";
    /** column name */
    PinCode_select_column["updatedByUserId"] = "updatedByUserId";
    /** column name */
    PinCode_select_column["userRoleId"] = "userRoleId";
})(PinCode_select_column || (exports.PinCode_select_column = PinCode_select_column = {}));
/** update columns of table "PinCode" */
var PinCode_update_column;
(function (PinCode_update_column) {
    /** column name */
    PinCode_update_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    PinCode_update_column["code"] = "code";
    /** column name */
    PinCode_update_column["createdAt"] = "createdAt";
    /** column name */
    PinCode_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    PinCode_update_column["pinCodeId"] = "pinCodeId";
    /** column name */
    PinCode_update_column["propertyId"] = "propertyId";
    /** column name */
    PinCode_update_column["sourcePayload"] = "sourcePayload";
    /** column name */
    PinCode_update_column["updatedAt"] = "updatedAt";
    /** column name */
    PinCode_update_column["updatedByUserId"] = "updatedByUserId";
    /** column name */
    PinCode_update_column["userRoleId"] = "userRoleId";
})(PinCode_update_column || (exports.PinCode_update_column = PinCode_update_column = {}));
/** unique or primary key constraints on table "PropertyFeatureFlag" */
var PropertyFeatureFlag_constraint;
(function (PropertyFeatureFlag_constraint) {
    /** unique or primary key constraint on columns "propertyFeatureFlagId" */
    PropertyFeatureFlag_constraint["PropertyFeatureFlag_pkey"] = "PropertyFeatureFlag_pkey";
    /** unique or primary key constraint on columns "propertyId", "featureFlagKey" */
    PropertyFeatureFlag_constraint["PropertyFeatureFlag_propertyId_featureFlagKey_key"] = "PropertyFeatureFlag_propertyId_featureFlagKey_key";
})(PropertyFeatureFlag_constraint || (exports.PropertyFeatureFlag_constraint = PropertyFeatureFlag_constraint = {}));
/** select columns of table "PropertyFeatureFlag" */
var PropertyFeatureFlag_select_column;
(function (PropertyFeatureFlag_select_column) {
    /** column name */
    PropertyFeatureFlag_select_column["createdAt"] = "createdAt";
    /** column name */
    PropertyFeatureFlag_select_column["featureFlagKey"] = "featureFlagKey";
    /** column name */
    PropertyFeatureFlag_select_column["propertyFeatureFlagId"] = "propertyFeatureFlagId";
    /** column name */
    PropertyFeatureFlag_select_column["propertyId"] = "propertyId";
})(PropertyFeatureFlag_select_column || (exports.PropertyFeatureFlag_select_column = PropertyFeatureFlag_select_column = {}));
/** update columns of table "PropertyFeatureFlag" */
var PropertyFeatureFlag_update_column;
(function (PropertyFeatureFlag_update_column) {
    /** column name */
    PropertyFeatureFlag_update_column["createdAt"] = "createdAt";
    /** column name */
    PropertyFeatureFlag_update_column["featureFlagKey"] = "featureFlagKey";
    /** column name */
    PropertyFeatureFlag_update_column["propertyFeatureFlagId"] = "propertyFeatureFlagId";
    /** column name */
    PropertyFeatureFlag_update_column["propertyId"] = "propertyId";
})(PropertyFeatureFlag_update_column || (exports.PropertyFeatureFlag_update_column = PropertyFeatureFlag_update_column = {}));
/** unique or primary key constraints on table "PropertyMapType" */
var PropertyMapType_constraint;
(function (PropertyMapType_constraint) {
    /** unique or primary key constraint on columns "label" */
    PropertyMapType_constraint["PropertyMapType_label_key"] = "PropertyMapType_label_key";
    /** unique or primary key constraint on columns "value" */
    PropertyMapType_constraint["PropertyMapType_pkey"] = "PropertyMapType_pkey";
})(PropertyMapType_constraint || (exports.PropertyMapType_constraint = PropertyMapType_constraint = {}));
var PropertyMapType_enum;
(function (PropertyMapType_enum) {
    /** Elevation */
    PropertyMapType_enum["ELEVATION"] = "ELEVATION";
    /** Floor Plate */
    PropertyMapType_enum["FLOOR_PLATE"] = "FLOOR_PLATE";
    /** Oblique */
    PropertyMapType_enum["OBLIQUE"] = "OBLIQUE";
    /** Stack */
    PropertyMapType_enum["STACK"] = "STACK";
})(PropertyMapType_enum || (exports.PropertyMapType_enum = PropertyMapType_enum = {}));
/** select columns of table "PropertyMapType" */
var PropertyMapType_select_column;
(function (PropertyMapType_select_column) {
    /** column name */
    PropertyMapType_select_column["label"] = "label";
    /** column name */
    PropertyMapType_select_column["value"] = "value";
})(PropertyMapType_select_column || (exports.PropertyMapType_select_column = PropertyMapType_select_column = {}));
/** update columns of table "PropertyMapType" */
var PropertyMapType_update_column;
(function (PropertyMapType_update_column) {
    /** column name */
    PropertyMapType_update_column["label"] = "label";
    /** column name */
    PropertyMapType_update_column["value"] = "value";
})(PropertyMapType_update_column || (exports.PropertyMapType_update_column = PropertyMapType_update_column = {}));
/** unique or primary key constraints on table "PropertyMap" */
var PropertyMap_constraint;
(function (PropertyMap_constraint) {
    /** unique or primary key constraint on columns "propertyMapId" */
    PropertyMap_constraint["PropertyMap_pkey"] = "PropertyMap_pkey";
    /** unique or primary key constraint on columns "propertyId" */
    PropertyMap_constraint["PropertyMap_propertyId_key"] = "PropertyMap_propertyId_key";
})(PropertyMap_constraint || (exports.PropertyMap_constraint = PropertyMap_constraint = {}));
/** select columns of table "PropertyMap" */
var PropertyMap_select_column;
(function (PropertyMap_select_column) {
    /** column name */
    PropertyMap_select_column["createdAt"] = "createdAt";
    /** column name */
    PropertyMap_select_column["externalAssetId"] = "externalAssetId";
    /** column name */
    PropertyMap_select_column["externalFloors"] = "externalFloors";
    /** column name */
    PropertyMap_select_column["externalMapId"] = "externalMapId";
    /** column name */
    PropertyMap_select_column["externalUnits"] = "externalUnits";
    /** column name */
    PropertyMap_select_column["propertyId"] = "propertyId";
    /** column name */
    PropertyMap_select_column["propertyMapId"] = "propertyMapId";
    /** column name */
    PropertyMap_select_column["published"] = "published";
    /** column name */
    PropertyMap_select_column["type"] = "type";
    /** column name */
    PropertyMap_select_column["updatedAt"] = "updatedAt";
})(PropertyMap_select_column || (exports.PropertyMap_select_column = PropertyMap_select_column = {}));
/** select "PropertyMap_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PropertyMap" */
var PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns;
(function (PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns["published"] = "published";
})(PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns || (exports.PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns = PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "PropertyMap_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PropertyMap" */
var PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns;
(function (PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns["published"] = "published";
})(PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns || (exports.PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns = PropertyMap_select_column_PropertyMap_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "PropertyMap" */
var PropertyMap_update_column;
(function (PropertyMap_update_column) {
    /** column name */
    PropertyMap_update_column["createdAt"] = "createdAt";
    /** column name */
    PropertyMap_update_column["externalAssetId"] = "externalAssetId";
    /** column name */
    PropertyMap_update_column["externalFloors"] = "externalFloors";
    /** column name */
    PropertyMap_update_column["externalMapId"] = "externalMapId";
    /** column name */
    PropertyMap_update_column["externalUnits"] = "externalUnits";
    /** column name */
    PropertyMap_update_column["propertyId"] = "propertyId";
    /** column name */
    PropertyMap_update_column["propertyMapId"] = "propertyMapId";
    /** column name */
    PropertyMap_update_column["published"] = "published";
    /** column name */
    PropertyMap_update_column["type"] = "type";
    /** column name */
    PropertyMap_update_column["updatedAt"] = "updatedAt";
})(PropertyMap_update_column || (exports.PropertyMap_update_column = PropertyMap_update_column = {}));
/** unique or primary key constraints on table "PropertySource" */
var PropertySource_constraint;
(function (PropertySource_constraint) {
    /** unique or primary key constraint on columns "propertySourceId" */
    PropertySource_constraint["PropertySource_pkey"] = "PropertySource_pkey";
    /** unique or primary key constraint on columns "sourceId" */
    PropertySource_constraint["PropertySource_sourceId_key"] = "PropertySource_sourceId_key";
})(PropertySource_constraint || (exports.PropertySource_constraint = PropertySource_constraint = {}));
/** select columns of table "PropertySource" */
var PropertySource_select_column;
(function (PropertySource_select_column) {
    /** column name */
    PropertySource_select_column["createdAt"] = "createdAt";
    /** column name */
    PropertySource_select_column["name"] = "name";
    /** column name */
    PropertySource_select_column["propertyId"] = "propertyId";
    /** column name */
    PropertySource_select_column["propertySourceId"] = "propertySourceId";
    /** column name */
    PropertySource_select_column["sourceId"] = "sourceId";
    /** column name */
    PropertySource_select_column["updatedAt"] = "updatedAt";
})(PropertySource_select_column || (exports.PropertySource_select_column = PropertySource_select_column = {}));
/** update columns of table "PropertySource" */
var PropertySource_update_column;
(function (PropertySource_update_column) {
    /** column name */
    PropertySource_update_column["createdAt"] = "createdAt";
    /** column name */
    PropertySource_update_column["name"] = "name";
    /** column name */
    PropertySource_update_column["propertyId"] = "propertyId";
    /** column name */
    PropertySource_update_column["propertySourceId"] = "propertySourceId";
    /** column name */
    PropertySource_update_column["sourceId"] = "sourceId";
    /** column name */
    PropertySource_update_column["updatedAt"] = "updatedAt";
})(PropertySource_update_column || (exports.PropertySource_update_column = PropertySource_update_column = {}));
/** unique or primary key constraints on table "PropertyVirtualDirectory" */
var PropertyVirtualDirectory_constraint;
(function (PropertyVirtualDirectory_constraint) {
    /** unique or primary key constraint on columns "propertyVirtualDirectoryId" */
    PropertyVirtualDirectory_constraint["PropertyVirtualDirectory_pkey"] = "PropertyVirtualDirectory_pkey";
    /** unique or primary key constraint on columns "propertyId" */
    PropertyVirtualDirectory_constraint["PropertyVirtualDirectory_propertyId_key"] = "PropertyVirtualDirectory_propertyId_key";
})(PropertyVirtualDirectory_constraint || (exports.PropertyVirtualDirectory_constraint = PropertyVirtualDirectory_constraint = {}));
/** select columns of table "PropertyVirtualDirectory" */
var PropertyVirtualDirectory_select_column;
(function (PropertyVirtualDirectory_select_column) {
    /** column name */
    PropertyVirtualDirectory_select_column["createdAt"] = "createdAt";
    /** column name */
    PropertyVirtualDirectory_select_column["leasingOfficeDisplayName"] = "leasingOfficeDisplayName";
    /** column name */
    PropertyVirtualDirectory_select_column["leasingOfficeHours"] = "leasingOfficeHours";
    /** column name */
    PropertyVirtualDirectory_select_column["leasingOfficePhoneNumber"] = "leasingOfficePhoneNumber";
    /** column name */
    PropertyVirtualDirectory_select_column["propertyId"] = "propertyId";
    /** column name */
    PropertyVirtualDirectory_select_column["propertyVirtualDirectoryId"] = "propertyVirtualDirectoryId";
    /** column name */
    PropertyVirtualDirectory_select_column["published"] = "published";
    /** column name */
    PropertyVirtualDirectory_select_column["updatedAt"] = "updatedAt";
    /** column name */
    PropertyVirtualDirectory_select_column["userDisplayNameFormat"] = "userDisplayNameFormat";
})(PropertyVirtualDirectory_select_column || (exports.PropertyVirtualDirectory_select_column = PropertyVirtualDirectory_select_column = {}));
/** select "PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns" columns of table "PropertyVirtualDirectory" */
var PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns;
(function (PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns["published"] = "published";
})(PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns || (exports.PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns = PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns" columns of table "PropertyVirtualDirectory" */
var PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns;
(function (PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns["published"] = "published";
})(PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns || (exports.PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns = PropertyVirtualDirectory_select_column_PropertyVirtualDirectory_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "PropertyVirtualDirectory" */
var PropertyVirtualDirectory_update_column;
(function (PropertyVirtualDirectory_update_column) {
    /** column name */
    PropertyVirtualDirectory_update_column["createdAt"] = "createdAt";
    /** column name */
    PropertyVirtualDirectory_update_column["leasingOfficeDisplayName"] = "leasingOfficeDisplayName";
    /** column name */
    PropertyVirtualDirectory_update_column["leasingOfficeHours"] = "leasingOfficeHours";
    /** column name */
    PropertyVirtualDirectory_update_column["leasingOfficePhoneNumber"] = "leasingOfficePhoneNumber";
    /** column name */
    PropertyVirtualDirectory_update_column["propertyId"] = "propertyId";
    /** column name */
    PropertyVirtualDirectory_update_column["propertyVirtualDirectoryId"] = "propertyVirtualDirectoryId";
    /** column name */
    PropertyVirtualDirectory_update_column["published"] = "published";
    /** column name */
    PropertyVirtualDirectory_update_column["updatedAt"] = "updatedAt";
    /** column name */
    PropertyVirtualDirectory_update_column["userDisplayNameFormat"] = "userDisplayNameFormat";
})(PropertyVirtualDirectory_update_column || (exports.PropertyVirtualDirectory_update_column = PropertyVirtualDirectory_update_column = {}));
/** unique or primary key constraints on table "Property" */
var Property_constraint;
(function (Property_constraint) {
    /** unique or primary key constraint on columns "funnelCommunityId" */
    Property_constraint["Property_funnelCommunityId_key"] = "Property_funnelCommunityId_key";
    /** unique or primary key constraint on columns "name", "organizationId" */
    Property_constraint["Property_organizationId_name_key"] = "Property_organizationId_name_key";
    /** unique or primary key constraint on columns "propertyId" */
    Property_constraint["Property_pkey"] = "Property_pkey";
})(Property_constraint || (exports.Property_constraint = Property_constraint = {}));
/** select columns of table "Property" */
var Property_select_column;
(function (Property_select_column) {
    /** column name */
    Property_select_column["address"] = "address";
    /** column name */
    Property_select_column["createdAt"] = "createdAt";
    /** column name */
    Property_select_column["funnelCommunityId"] = "funnelCommunityId";
    /** column name */
    Property_select_column["imageId"] = "imageId";
    /** column name */
    Property_select_column["name"] = "name";
    /** column name */
    Property_select_column["organizationId"] = "organizationId";
    /** column name */
    Property_select_column["propertyId"] = "propertyId";
    /** column name */
    Property_select_column["supportEmail"] = "supportEmail";
    /** column name */
    Property_select_column["supportPhoneNumber"] = "supportPhoneNumber";
    /** column name */
    Property_select_column["timezone"] = "timezone";
    /** column name */
    Property_select_column["updatedAt"] = "updatedAt";
    /** column name */
    Property_select_column["virtualDirectoryPhoneNumber"] = "virtualDirectoryPhoneNumber";
    /** column name */
    Property_select_column["virtualDirectoryStaffHours"] = "virtualDirectoryStaffHours";
})(Property_select_column || (exports.Property_select_column = Property_select_column = {}));
/** update columns of table "Property" */
var Property_update_column;
(function (Property_update_column) {
    /** column name */
    Property_update_column["address"] = "address";
    /** column name */
    Property_update_column["createdAt"] = "createdAt";
    /** column name */
    Property_update_column["funnelCommunityId"] = "funnelCommunityId";
    /** column name */
    Property_update_column["imageId"] = "imageId";
    /** column name */
    Property_update_column["name"] = "name";
    /** column name */
    Property_update_column["organizationId"] = "organizationId";
    /** column name */
    Property_update_column["propertyId"] = "propertyId";
    /** column name */
    Property_update_column["supportEmail"] = "supportEmail";
    /** column name */
    Property_update_column["supportPhoneNumber"] = "supportPhoneNumber";
    /** column name */
    Property_update_column["timezone"] = "timezone";
    /** column name */
    Property_update_column["updatedAt"] = "updatedAt";
    /** column name */
    Property_update_column["virtualDirectoryPhoneNumber"] = "virtualDirectoryPhoneNumber";
    /** column name */
    Property_update_column["virtualDirectoryStaffHours"] = "virtualDirectoryStaffHours";
})(Property_update_column || (exports.Property_update_column = Property_update_column = {}));
/** unique or primary key constraints on table "ReaderType" */
var ReaderType_constraint;
(function (ReaderType_constraint) {
    /** unique or primary key constraint on columns "value" */
    ReaderType_constraint["ReaderType_pkey"] = "ReaderType_pkey";
})(ReaderType_constraint || (exports.ReaderType_constraint = ReaderType_constraint = {}));
var ReaderType_enum;
(function (ReaderType_enum) {
    ReaderType_enum["KEYPAD"] = "KEYPAD";
    ReaderType_enum["LONG_RANGE"] = "LONG_RANGE";
    ReaderType_enum["NON_KEYPAD"] = "NON_KEYPAD";
})(ReaderType_enum || (exports.ReaderType_enum = ReaderType_enum = {}));
/** select columns of table "ReaderType" */
var ReaderType_select_column;
(function (ReaderType_select_column) {
    /** column name */
    ReaderType_select_column["value"] = "value";
})(ReaderType_select_column || (exports.ReaderType_select_column = ReaderType_select_column = {}));
/** update columns of table "ReaderType" */
var ReaderType_update_column;
(function (ReaderType_update_column) {
    /** column name */
    ReaderType_update_column["value"] = "value";
})(ReaderType_update_column || (exports.ReaderType_update_column = ReaderType_update_column = {}));
/** unique or primary key constraints on table "RelayLog" */
var RelayLog_constraint;
(function (RelayLog_constraint) {
    /** unique or primary key constraint on columns "relayLogId" */
    RelayLog_constraint["RelayLog_pkey"] = "RelayLog_pkey";
})(RelayLog_constraint || (exports.RelayLog_constraint = RelayLog_constraint = {}));
/** select columns of table "RelayLog" */
var RelayLog_select_column;
(function (RelayLog_select_column) {
    /** column name */
    RelayLog_select_column["accessPointId"] = "accessPointId";
    /** column name */
    RelayLog_select_column["createdAt"] = "createdAt";
    /** column name */
    RelayLog_select_column["inputRelayId"] = "inputRelayId";
    /** column name */
    RelayLog_select_column["propertyId"] = "propertyId";
    /** column name */
    RelayLog_select_column["readerInput"] = "readerInput";
    /** column name */
    RelayLog_select_column["relayId"] = "relayId";
    /** column name */
    RelayLog_select_column["relayLogId"] = "relayLogId";
    /** column name */
    RelayLog_select_column["unlockMethod"] = "unlockMethod";
    /** column name */
    RelayLog_select_column["unlockResult"] = "unlockResult";
    /** column name */
    RelayLog_select_column["userId"] = "userId";
    /** column name */
    RelayLog_select_column["userRoleId"] = "userRoleId";
})(RelayLog_select_column || (exports.RelayLog_select_column = RelayLog_select_column = {}));
/** update columns of table "RelayLog" */
var RelayLog_update_column;
(function (RelayLog_update_column) {
    /** column name */
    RelayLog_update_column["accessPointId"] = "accessPointId";
    /** column name */
    RelayLog_update_column["createdAt"] = "createdAt";
    /** column name */
    RelayLog_update_column["inputRelayId"] = "inputRelayId";
    /** column name */
    RelayLog_update_column["propertyId"] = "propertyId";
    /** column name */
    RelayLog_update_column["readerInput"] = "readerInput";
    /** column name */
    RelayLog_update_column["relayId"] = "relayId";
    /** column name */
    RelayLog_update_column["relayLogId"] = "relayLogId";
    /** column name */
    RelayLog_update_column["unlockMethod"] = "unlockMethod";
    /** column name */
    RelayLog_update_column["unlockResult"] = "unlockResult";
    /** column name */
    RelayLog_update_column["userId"] = "userId";
    /** column name */
    RelayLog_update_column["userRoleId"] = "userRoleId";
})(RelayLog_update_column || (exports.RelayLog_update_column = RelayLog_update_column = {}));
/** unique or primary key constraints on table "Relay" */
var Relay_constraint;
(function (Relay_constraint) {
    /** unique or primary key constraint on columns "hubId", "gpioMode", "position" */
    Relay_constraint["Relay_hubId_position_gpioMode_key"] = "Relay_hubId_position_gpioMode_key";
    /** unique or primary key constraint on columns "hubId", "gpioMode", "readerSerialNumber", "position" */
    Relay_constraint["Relay_hubId_position_gpioMode_readerSerialNumber_key"] = "Relay_hubId_position_gpioMode_readerSerialNumber_key";
    /** unique or primary key constraint on columns "relayId" */
    Relay_constraint["Relay_pkey"] = "Relay_pkey";
})(Relay_constraint || (exports.Relay_constraint = Relay_constraint = {}));
/** select columns of table "Relay" */
var Relay_select_column;
(function (Relay_select_column) {
    /** column name */
    Relay_select_column["childHubId"] = "childHubId";
    /** column name */
    Relay_select_column["createdAt"] = "createdAt";
    /** column name */
    Relay_select_column["failurePlan"] = "failurePlan";
    /** column name */
    Relay_select_column["gpioMode"] = "gpioMode";
    /** column name */
    Relay_select_column["hubId"] = "hubId";
    /** column name */
    Relay_select_column["inputDevice"] = "inputDevice";
    /** column name */
    Relay_select_column["name"] = "name";
    /** column name */
    Relay_select_column["position"] = "position";
    /** column name */
    Relay_select_column["readerAddress"] = "readerAddress";
    /** column name */
    Relay_select_column["readerSerialNumber"] = "readerSerialNumber";
    /** column name */
    Relay_select_column["readerType"] = "readerType";
    /** column name */
    Relay_select_column["relayId"] = "relayId";
    /** column name */
    Relay_select_column["unlockOnInternetFailure"] = "unlockOnInternetFailure";
    /** column name */
    Relay_select_column["updatedAt"] = "updatedAt";
})(Relay_select_column || (exports.Relay_select_column = Relay_select_column = {}));
/** select "Relay_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Relay" */
var Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns;
(function (Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns["unlockOnInternetFailure"] = "unlockOnInternetFailure";
})(Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns || (exports.Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns = Relay_select_column_Relay_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "Relay_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Relay" */
var Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns;
(function (Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns["unlockOnInternetFailure"] = "unlockOnInternetFailure";
})(Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns || (exports.Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns = Relay_select_column_Relay_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "Relay" */
var Relay_update_column;
(function (Relay_update_column) {
    /** column name */
    Relay_update_column["childHubId"] = "childHubId";
    /** column name */
    Relay_update_column["createdAt"] = "createdAt";
    /** column name */
    Relay_update_column["failurePlan"] = "failurePlan";
    /** column name */
    Relay_update_column["gpioMode"] = "gpioMode";
    /** column name */
    Relay_update_column["hubId"] = "hubId";
    /** column name */
    Relay_update_column["inputDevice"] = "inputDevice";
    /** column name */
    Relay_update_column["name"] = "name";
    /** column name */
    Relay_update_column["position"] = "position";
    /** column name */
    Relay_update_column["readerAddress"] = "readerAddress";
    /** column name */
    Relay_update_column["readerSerialNumber"] = "readerSerialNumber";
    /** column name */
    Relay_update_column["readerType"] = "readerType";
    /** column name */
    Relay_update_column["relayId"] = "relayId";
    /** column name */
    Relay_update_column["unlockOnInternetFailure"] = "unlockOnInternetFailure";
    /** column name */
    Relay_update_column["updatedAt"] = "updatedAt";
})(Relay_update_column || (exports.Relay_update_column = Relay_update_column = {}));
/** unique or primary key constraints on table "RoleKey" */
var RoleKey_constraint;
(function (RoleKey_constraint) {
    /** unique or primary key constraint on columns "value" */
    RoleKey_constraint["RoleKey_pkey"] = "RoleKey_pkey";
})(RoleKey_constraint || (exports.RoleKey_constraint = RoleKey_constraint = {}));
var RoleKey_enum;
(function (RoleKey_enum) {
    RoleKey_enum["AMENITY_ACCESS"] = "AMENITY_ACCESS";
    RoleKey_enum["BASIC_ACCESS"] = "BASIC_ACCESS";
    RoleKey_enum["GUEST_PROPERTY_KEY"] = "GUEST_PROPERTY_KEY";
    RoleKey_enum["GUEST_UNIT_KEY"] = "GUEST_UNIT_KEY";
    RoleKey_enum["INTEGRATOR"] = "INTEGRATOR";
    RoleKey_enum["INTEGRATOR_GATEWAY"] = "INTEGRATOR_GATEWAY";
    RoleKey_enum["INTEGRATOR_GATEWAY_CERTIFICATION"] = "INTEGRATOR_GATEWAY_CERTIFICATION";
    RoleKey_enum["INTEGRATOR_HOME_ACCESS"] = "INTEGRATOR_HOME_ACCESS";
    RoleKey_enum["INTEGRATOR_SUPERVISOR_ORGANIZATION"] = "INTEGRATOR_SUPERVISOR_ORGANIZATION";
    RoleKey_enum["INTEGRATOR_SUPERVISOR_PROPERTY"] = "INTEGRATOR_SUPERVISOR_PROPERTY";
    RoleKey_enum["RESERVATION"] = "RESERVATION";
    RoleKey_enum["RESIDENT"] = "RESIDENT";
    RoleKey_enum["ROLE_MANAGER"] = "ROLE_MANAGER";
    RoleKey_enum["SBP_SUPERUSER"] = "SBP_SUPERUSER";
    RoleKey_enum["SMART_LOCK_UNREGISTERED_USER"] = "SMART_LOCK_UNREGISTERED_USER";
    RoleKey_enum["STAFF_PROPERTY_KEY"] = "STAFF_PROPERTY_KEY";
    RoleKey_enum["STAFF_UNIT_KEY"] = "STAFF_UNIT_KEY";
    RoleKey_enum["STRATIS_MAINTENANCE"] = "STRATIS_MAINTENANCE";
    RoleKey_enum["STRATIS_OFFICE_STAFF"] = "STRATIS_OFFICE_STAFF";
    RoleKey_enum["STRATIS_PROPERTY_MANAGER"] = "STRATIS_PROPERTY_MANAGER";
    RoleKey_enum["STRATIS_RESIDENT"] = "STRATIS_RESIDENT";
    RoleKey_enum["SUPER_ADMIN"] = "SUPER_ADMIN";
    RoleKey_enum["SUPER_ADMIN_READ_ONLY"] = "SUPER_ADMIN_READ_ONLY";
    RoleKey_enum["VENDOR_PASS"] = "VENDOR_PASS";
})(RoleKey_enum || (exports.RoleKey_enum = RoleKey_enum = {}));
/** select columns of table "RoleKey" */
var RoleKey_select_column;
(function (RoleKey_select_column) {
    /** column name */
    RoleKey_select_column["value"] = "value";
})(RoleKey_select_column || (exports.RoleKey_select_column = RoleKey_select_column = {}));
/** update columns of table "RoleKey" */
var RoleKey_update_column;
(function (RoleKey_update_column) {
    /** column name */
    RoleKey_update_column["value"] = "value";
})(RoleKey_update_column || (exports.RoleKey_update_column = RoleKey_update_column = {}));
/** unique or primary key constraints on table "RolePermission" */
var RolePermission_constraint;
(function (RolePermission_constraint) {
    /** unique or primary key constraint on columns "rolePermissionId" */
    RolePermission_constraint["RolePermission_pkey"] = "RolePermission_pkey";
    /** unique or primary key constraint on columns "permissionId", "roleId" */
    RolePermission_constraint["RolePermission_roleId_permissionId_key"] = "RolePermission_roleId_permissionId_key";
})(RolePermission_constraint || (exports.RolePermission_constraint = RolePermission_constraint = {}));
/** select columns of table "RolePermission" */
var RolePermission_select_column;
(function (RolePermission_select_column) {
    /** column name */
    RolePermission_select_column["createdAt"] = "createdAt";
    /** column name */
    RolePermission_select_column["permissionId"] = "permissionId";
    /** column name */
    RolePermission_select_column["roleId"] = "roleId";
    /** column name */
    RolePermission_select_column["rolePermissionId"] = "rolePermissionId";
})(RolePermission_select_column || (exports.RolePermission_select_column = RolePermission_select_column = {}));
/** update columns of table "RolePermission" */
var RolePermission_update_column;
(function (RolePermission_update_column) {
    /** column name */
    RolePermission_update_column["createdAt"] = "createdAt";
    /** column name */
    RolePermission_update_column["permissionId"] = "permissionId";
    /** column name */
    RolePermission_update_column["roleId"] = "roleId";
    /** column name */
    RolePermission_update_column["rolePermissionId"] = "rolePermissionId";
})(RolePermission_update_column || (exports.RolePermission_update_column = RolePermission_update_column = {}));
/** unique or primary key constraints on table "RoleRelationship" */
var RoleRelationship_constraint;
(function (RoleRelationship_constraint) {
    /** unique or primary key constraint on columns "roleRelationshipId" */
    RoleRelationship_constraint["RoleRelationship_pkey"] = "RoleRelationship_pkey";
    /** unique or primary key constraint on columns "relatedRoleId", "roleId" */
    RoleRelationship_constraint["RoleRelationship_roleId_relatedRoleId_key"] = "RoleRelationship_roleId_relatedRoleId_key";
})(RoleRelationship_constraint || (exports.RoleRelationship_constraint = RoleRelationship_constraint = {}));
/** select columns of table "RoleRelationship" */
var RoleRelationship_select_column;
(function (RoleRelationship_select_column) {
    /** column name */
    RoleRelationship_select_column["canGrantUserRole"] = "canGrantUserRole";
    /** column name */
    RoleRelationship_select_column["canReadUserRole"] = "canReadUserRole";
    /** column name */
    RoleRelationship_select_column["canRevokeUserRole"] = "canRevokeUserRole";
    /** column name */
    RoleRelationship_select_column["createdAt"] = "createdAt";
    /** column name */
    RoleRelationship_select_column["relatedRoleId"] = "relatedRoleId";
    /** column name */
    RoleRelationship_select_column["roleId"] = "roleId";
    /** column name */
    RoleRelationship_select_column["roleRelationshipId"] = "roleRelationshipId";
    /** column name */
    RoleRelationship_select_column["updatedAt"] = "updatedAt";
})(RoleRelationship_select_column || (exports.RoleRelationship_select_column = RoleRelationship_select_column = {}));
/** select "RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns" columns of table "RoleRelationship" */
var RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns;
(function (RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns["canGrantUserRole"] = "canGrantUserRole";
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns["canReadUserRole"] = "canReadUserRole";
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns["canRevokeUserRole"] = "canRevokeUserRole";
})(RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns || (exports.RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns = RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns" columns of table "RoleRelationship" */
var RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns;
(function (RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns["canGrantUserRole"] = "canGrantUserRole";
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns["canReadUserRole"] = "canReadUserRole";
    /** column name */
    RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns["canRevokeUserRole"] = "canRevokeUserRole";
})(RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns || (exports.RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns = RoleRelationship_select_column_RoleRelationship_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "RoleRelationship" */
var RoleRelationship_update_column;
(function (RoleRelationship_update_column) {
    /** column name */
    RoleRelationship_update_column["canGrantUserRole"] = "canGrantUserRole";
    /** column name */
    RoleRelationship_update_column["canReadUserRole"] = "canReadUserRole";
    /** column name */
    RoleRelationship_update_column["canRevokeUserRole"] = "canRevokeUserRole";
    /** column name */
    RoleRelationship_update_column["createdAt"] = "createdAt";
    /** column name */
    RoleRelationship_update_column["relatedRoleId"] = "relatedRoleId";
    /** column name */
    RoleRelationship_update_column["roleId"] = "roleId";
    /** column name */
    RoleRelationship_update_column["roleRelationshipId"] = "roleRelationshipId";
    /** column name */
    RoleRelationship_update_column["updatedAt"] = "updatedAt";
})(RoleRelationship_update_column || (exports.RoleRelationship_update_column = RoleRelationship_update_column = {}));
/** unique or primary key constraints on table "Role" */
var Role_constraint;
(function (Role_constraint) {
    /** unique or primary key constraint on columns "key" */
    Role_constraint["Role_key_key"] = "Role_key_key";
    /** unique or primary key constraint on columns "name", "permissionScope" */
    Role_constraint["Role_name_permissionScope_key"] = "Role_name_permissionScope_key";
    /** unique or primary key constraint on columns "name", "organizationId", "permissionScope" */
    Role_constraint["Role_organizationId_name_permissionScope_key"] = "Role_organizationId_name_permissionScope_key";
    /** unique or primary key constraint on columns "organizationId", "uniqueName" */
    Role_constraint["Role_organizationId_uniqueName_key"] = "Role_organizationId_uniqueName_key";
    /** unique or primary key constraint on columns "roleId" */
    Role_constraint["Role_pkey"] = "Role_pkey";
    /** unique or primary key constraint on columns "uniqueName" */
    Role_constraint["Role_uniqueName_key"] = "Role_uniqueName_key";
})(Role_constraint || (exports.Role_constraint = Role_constraint = {}));
/** select columns of table "Role" */
var Role_select_column;
(function (Role_select_column) {
    /** column name */
    Role_select_column["createdAt"] = "createdAt";
    /** column name */
    Role_select_column["deprecatedType"] = "deprecatedType";
    /** column name */
    Role_select_column["description"] = "description";
    /** column name */
    Role_select_column["isLocked"] = "isLocked";
    /** column name */
    Role_select_column["key"] = "key";
    /** column name */
    Role_select_column["maxAccessDurationSeconds"] = "maxAccessDurationSeconds";
    /** column name */
    Role_select_column["name"] = "name";
    /** column name */
    Role_select_column["organizationId"] = "organizationId";
    /** column name */
    Role_select_column["permissionScope"] = "permissionScope";
    /** column name */
    Role_select_column["roleId"] = "roleId";
    /** column name */
    Role_select_column["uniqueName"] = "uniqueName";
    /** column name */
    Role_select_column["updatedAt"] = "updatedAt";
})(Role_select_column || (exports.Role_select_column = Role_select_column = {}));
/** select "Role_aggregate_bool_exp_bool_and_arguments_columns" columns of table "Role" */
var Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns;
(function (Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns["isLocked"] = "isLocked";
})(Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns || (exports.Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns = Role_select_column_Role_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "Role_aggregate_bool_exp_bool_or_arguments_columns" columns of table "Role" */
var Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns;
(function (Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns["isLocked"] = "isLocked";
})(Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns || (exports.Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns = Role_select_column_Role_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "Role" */
var Role_update_column;
(function (Role_update_column) {
    /** column name */
    Role_update_column["createdAt"] = "createdAt";
    /** column name */
    Role_update_column["deprecatedType"] = "deprecatedType";
    /** column name */
    Role_update_column["description"] = "description";
    /** column name */
    Role_update_column["isLocked"] = "isLocked";
    /** column name */
    Role_update_column["key"] = "key";
    /** column name */
    Role_update_column["maxAccessDurationSeconds"] = "maxAccessDurationSeconds";
    /** column name */
    Role_update_column["name"] = "name";
    /** column name */
    Role_update_column["organizationId"] = "organizationId";
    /** column name */
    Role_update_column["permissionScope"] = "permissionScope";
    /** column name */
    Role_update_column["roleId"] = "roleId";
    /** column name */
    Role_update_column["uniqueName"] = "uniqueName";
    /** column name */
    Role_update_column["updatedAt"] = "updatedAt";
})(Role_update_column || (exports.Role_update_column = Role_update_column = {}));
/** unique or primary key constraints on table "SessionType" */
var SessionType_constraint;
(function (SessionType_constraint) {
    /** unique or primary key constraint on columns "label" */
    SessionType_constraint["SessionType_label_key"] = "SessionType_label_key";
    /** unique or primary key constraint on columns "value" */
    SessionType_constraint["SessionType_pkey"] = "SessionType_pkey";
})(SessionType_constraint || (exports.SessionType_constraint = SessionType_constraint = {}));
var SessionType_enum;
(function (SessionType_enum) {
    /** Access App */
    SessionType_enum["ACCESS_APP"] = "ACCESS_APP";
    /** Admin Panel */
    SessionType_enum["ADMIN_PANEL"] = "ADMIN_PANEL";
})(SessionType_enum || (exports.SessionType_enum = SessionType_enum = {}));
/** select columns of table "SessionType" */
var SessionType_select_column;
(function (SessionType_select_column) {
    /** column name */
    SessionType_select_column["label"] = "label";
    /** column name */
    SessionType_select_column["value"] = "value";
})(SessionType_select_column || (exports.SessionType_select_column = SessionType_select_column = {}));
/** update columns of table "SessionType" */
var SessionType_update_column;
(function (SessionType_update_column) {
    /** column name */
    SessionType_update_column["label"] = "label";
    /** column name */
    SessionType_update_column["value"] = "value";
})(SessionType_update_column || (exports.SessionType_update_column = SessionType_update_column = {}));
/** unique or primary key constraints on table "Session" */
var Session_constraint;
(function (Session_constraint) {
    /** unique or primary key constraint on columns "chirpRefreshToken" */
    Session_constraint["Session_chirpRefreshToken_key"] = "Session_chirpRefreshToken_key";
    /** unique or primary key constraint on columns "sessionId" */
    Session_constraint["Session_pkey"] = "Session_pkey";
})(Session_constraint || (exports.Session_constraint = Session_constraint = {}));
/** select columns of table "Session" */
var Session_select_column;
(function (Session_select_column) {
    /** column name */
    Session_select_column["authMethod"] = "authMethod";
    /** column name */
    Session_select_column["chirpRefreshToken"] = "chirpRefreshToken";
    /** column name */
    Session_select_column["createdAt"] = "createdAt";
    /** column name */
    Session_select_column["deviceFingerprint"] = "deviceFingerprint";
    /** column name */
    Session_select_column["deviceInfo"] = "deviceInfo";
    /** column name */
    Session_select_column["expiresAt"] = "expiresAt";
    /** column name */
    Session_select_column["renewedAt"] = "renewedAt";
    /** column name */
    Session_select_column["revokedAt"] = "revokedAt";
    /** column name */
    Session_select_column["revokedByUserId"] = "revokedByUserId";
    /** column name */
    Session_select_column["sessionId"] = "sessionId";
    /** column name */
    Session_select_column["type"] = "type";
    /** column name */
    Session_select_column["userId"] = "userId";
})(Session_select_column || (exports.Session_select_column = Session_select_column = {}));
/** update columns of table "Session" */
var Session_update_column;
(function (Session_update_column) {
    /** column name */
    Session_update_column["authMethod"] = "authMethod";
    /** column name */
    Session_update_column["chirpRefreshToken"] = "chirpRefreshToken";
    /** column name */
    Session_update_column["createdAt"] = "createdAt";
    /** column name */
    Session_update_column["deviceFingerprint"] = "deviceFingerprint";
    /** column name */
    Session_update_column["deviceInfo"] = "deviceInfo";
    /** column name */
    Session_update_column["expiresAt"] = "expiresAt";
    /** column name */
    Session_update_column["renewedAt"] = "renewedAt";
    /** column name */
    Session_update_column["revokedAt"] = "revokedAt";
    /** column name */
    Session_update_column["revokedByUserId"] = "revokedByUserId";
    /** column name */
    Session_update_column["sessionId"] = "sessionId";
    /** column name */
    Session_update_column["type"] = "type";
    /** column name */
    Session_update_column["userId"] = "userId";
})(Session_update_column || (exports.Session_update_column = Session_update_column = {}));
/** unique or primary key constraints on table "SmartLockLogType" */
var SmartLockLogType_constraint;
(function (SmartLockLogType_constraint) {
    /** unique or primary key constraint on columns "label" */
    SmartLockLogType_constraint["SmartLockLogType_label_key"] = "SmartLockLogType_label_key";
    /** unique or primary key constraint on columns "value" */
    SmartLockLogType_constraint["SmartLockLogType_pkey"] = "SmartLockLogType_pkey";
})(SmartLockLogType_constraint || (exports.SmartLockLogType_constraint = SmartLockLogType_constraint = {}));
var SmartLockLogType_enum;
(function (SmartLockLogType_enum) {
    /** Lock - Manual */
    SmartLockLogType_enum["LOCK_MANUAL"] = "LOCK_MANUAL";
    /** Lock - Via App */
    SmartLockLogType_enum["LOCK_VIA_APP"] = "LOCK_VIA_APP";
    /** Lock - Via Auto-Lock */
    SmartLockLogType_enum["LOCK_VIA_AUTO_LOCK"] = "LOCK_VIA_AUTO_LOCK";
    /** Lock - Via Keypad */
    SmartLockLogType_enum["LOCK_VIA_KEYPAD"] = "LOCK_VIA_KEYPAD";
    /** Pin Code Management - Create */
    SmartLockLogType_enum["PIN_CODE_MANAGEMENT_CREATE"] = "PIN_CODE_MANAGEMENT_CREATE";
    /** Pin Code Management - Delete */
    SmartLockLogType_enum["PIN_CODE_MANAGEMENT_DELETE"] = "PIN_CODE_MANAGEMENT_DELETE";
    /** Unlock - Manual */
    SmartLockLogType_enum["UNLOCK_MANUAL"] = "UNLOCK_MANUAL";
    /** Unlock - Via App */
    SmartLockLogType_enum["UNLOCK_VIA_APP"] = "UNLOCK_VIA_APP";
    /** Unlock - Via Keypad */
    SmartLockLogType_enum["UNLOCK_VIA_KEYPAD"] = "UNLOCK_VIA_KEYPAD";
    /** User Management - Add */
    SmartLockLogType_enum["USER_MANAGEMENT_ADD"] = "USER_MANAGEMENT_ADD";
    /** User Management - Remove */
    SmartLockLogType_enum["USER_MANAGEMENT_REMOVE"] = "USER_MANAGEMENT_REMOVE";
})(SmartLockLogType_enum || (exports.SmartLockLogType_enum = SmartLockLogType_enum = {}));
/** select columns of table "SmartLockLogType" */
var SmartLockLogType_select_column;
(function (SmartLockLogType_select_column) {
    /** column name */
    SmartLockLogType_select_column["label"] = "label";
    /** column name */
    SmartLockLogType_select_column["value"] = "value";
})(SmartLockLogType_select_column || (exports.SmartLockLogType_select_column = SmartLockLogType_select_column = {}));
/** update columns of table "SmartLockLogType" */
var SmartLockLogType_update_column;
(function (SmartLockLogType_update_column) {
    /** column name */
    SmartLockLogType_update_column["label"] = "label";
    /** column name */
    SmartLockLogType_update_column["value"] = "value";
})(SmartLockLogType_update_column || (exports.SmartLockLogType_update_column = SmartLockLogType_update_column = {}));
/** unique or primary key constraints on table "SmartLockLog" */
var SmartLockLog_constraint;
(function (SmartLockLog_constraint) {
    /** unique or primary key constraint on columns "deprecatedSourceId" */
    SmartLockLog_constraint["SmartLockLog_deprecatedSourceId_key"] = "SmartLockLog_deprecatedSourceId_key";
    /** unique or primary key constraint on columns "smartLockLogId" */
    SmartLockLog_constraint["SmartLockLog_pkey"] = "SmartLockLog_pkey";
    /** unique or primary key constraint on columns "sourceId" */
    SmartLockLog_constraint["SmartLockLog_sourceId_key"] = "SmartLockLog_sourceId_key";
})(SmartLockLog_constraint || (exports.SmartLockLog_constraint = SmartLockLog_constraint = {}));
/** select columns of table "SmartLockLog" */
var SmartLockLog_select_column;
(function (SmartLockLog_select_column) {
    /** column name */
    SmartLockLog_select_column["actingUserId"] = "actingUserId";
    /** column name */
    SmartLockLog_select_column["actingUserRoleId"] = "actingUserRoleId";
    /** column name */
    SmartLockLog_select_column["affectedUserId"] = "affectedUserId";
    /** column name */
    SmartLockLog_select_column["affectedUserRoleId"] = "affectedUserRoleId";
    /** column name */
    SmartLockLog_select_column["createdAt"] = "createdAt";
    /** column name */
    SmartLockLog_select_column["deprecatedSourceId"] = "deprecatedSourceId";
    /** column name */
    SmartLockLog_select_column["smartLockId"] = "smartLockId";
    /** column name */
    SmartLockLog_select_column["smartLockLogId"] = "smartLockLogId";
    /** column name */
    SmartLockLog_select_column["sourceId"] = "sourceId";
    /** column name */
    SmartLockLog_select_column["type"] = "type";
})(SmartLockLog_select_column || (exports.SmartLockLog_select_column = SmartLockLog_select_column = {}));
/** update columns of table "SmartLockLog" */
var SmartLockLog_update_column;
(function (SmartLockLog_update_column) {
    /** column name */
    SmartLockLog_update_column["actingUserId"] = "actingUserId";
    /** column name */
    SmartLockLog_update_column["actingUserRoleId"] = "actingUserRoleId";
    /** column name */
    SmartLockLog_update_column["affectedUserId"] = "affectedUserId";
    /** column name */
    SmartLockLog_update_column["affectedUserRoleId"] = "affectedUserRoleId";
    /** column name */
    SmartLockLog_update_column["createdAt"] = "createdAt";
    /** column name */
    SmartLockLog_update_column["deprecatedSourceId"] = "deprecatedSourceId";
    /** column name */
    SmartLockLog_update_column["smartLockId"] = "smartLockId";
    /** column name */
    SmartLockLog_update_column["smartLockLogId"] = "smartLockLogId";
    /** column name */
    SmartLockLog_update_column["sourceId"] = "sourceId";
    /** column name */
    SmartLockLog_update_column["type"] = "type";
})(SmartLockLog_update_column || (exports.SmartLockLog_update_column = SmartLockLog_update_column = {}));
/** unique or primary key constraints on table "SmartLock" */
var SmartLock_constraint;
(function (SmartLock_constraint) {
    /** unique or primary key constraint on columns "smartLockId" */
    SmartLock_constraint["SmartLock_pkey"] = "SmartLock_pkey";
    /** unique or primary key constraint on columns "serialNumber" */
    SmartLock_constraint["SmartLock_serialNumber_key"] = "SmartLock_serialNumber_key";
    /** unique or primary key constraint on columns "sourceId" */
    SmartLock_constraint["SmartLock_sourceId_key"] = "SmartLock_sourceId_key";
    /** unique or primary key constraint on columns "name", "unitId" */
    SmartLock_constraint["SmartLock_unitId_name_key"] = "SmartLock_unitId_name_key";
})(SmartLock_constraint || (exports.SmartLock_constraint = SmartLock_constraint = {}));
/** select columns of table "SmartLock" */
var SmartLock_select_column;
(function (SmartLock_select_column) {
    /** column name */
    SmartLock_select_column["createdAt"] = "createdAt";
    /** column name */
    SmartLock_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    SmartLock_select_column["enabled"] = "enabled";
    /** column name */
    SmartLock_select_column["name"] = "name";
    /** column name */
    SmartLock_select_column["serialNumber"] = "serialNumber";
    /** column name */
    SmartLock_select_column["smartLockId"] = "smartLockId";
    /** column name */
    SmartLock_select_column["sourceId"] = "sourceId";
    /** column name */
    SmartLock_select_column["unitId"] = "unitId";
    /** column name */
    SmartLock_select_column["updatedAt"] = "updatedAt";
})(SmartLock_select_column || (exports.SmartLock_select_column = SmartLock_select_column = {}));
/** select "SmartLock_aggregate_bool_exp_bool_and_arguments_columns" columns of table "SmartLock" */
var SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns;
(function (SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns["enabled"] = "enabled";
})(SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns || (exports.SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns = SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "SmartLock_aggregate_bool_exp_bool_or_arguments_columns" columns of table "SmartLock" */
var SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns;
(function (SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns["enabled"] = "enabled";
})(SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns || (exports.SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns = SmartLock_select_column_SmartLock_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "SmartLock" */
var SmartLock_update_column;
(function (SmartLock_update_column) {
    /** column name */
    SmartLock_update_column["createdAt"] = "createdAt";
    /** column name */
    SmartLock_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    SmartLock_update_column["enabled"] = "enabled";
    /** column name */
    SmartLock_update_column["name"] = "name";
    /** column name */
    SmartLock_update_column["serialNumber"] = "serialNumber";
    /** column name */
    SmartLock_update_column["smartLockId"] = "smartLockId";
    /** column name */
    SmartLock_update_column["sourceId"] = "sourceId";
    /** column name */
    SmartLock_update_column["unitId"] = "unitId";
    /** column name */
    SmartLock_update_column["updatedAt"] = "updatedAt";
})(SmartLock_update_column || (exports.SmartLock_update_column = SmartLock_update_column = {}));
/** unique or primary key constraints on table "TicketStatus" */
var TicketStatus_constraint;
(function (TicketStatus_constraint) {
    /** unique or primary key constraint on columns "label" */
    TicketStatus_constraint["TicketStatus_label_key"] = "TicketStatus_label_key";
    /** unique or primary key constraint on columns "value" */
    TicketStatus_constraint["TicketStatus_pkey"] = "TicketStatus_pkey";
})(TicketStatus_constraint || (exports.TicketStatus_constraint = TicketStatus_constraint = {}));
var TicketStatus_enum;
(function (TicketStatus_enum) {
    /** Pending */
    TicketStatus_enum["PENDING"] = "PENDING";
    /** Solved */
    TicketStatus_enum["SOLVED"] = "SOLVED";
    /** Unsolved */
    TicketStatus_enum["UNSOLVED"] = "UNSOLVED";
})(TicketStatus_enum || (exports.TicketStatus_enum = TicketStatus_enum = {}));
/** select columns of table "TicketStatus" */
var TicketStatus_select_column;
(function (TicketStatus_select_column) {
    /** column name */
    TicketStatus_select_column["label"] = "label";
    /** column name */
    TicketStatus_select_column["value"] = "value";
})(TicketStatus_select_column || (exports.TicketStatus_select_column = TicketStatus_select_column = {}));
/** update columns of table "TicketStatus" */
var TicketStatus_update_column;
(function (TicketStatus_update_column) {
    /** column name */
    TicketStatus_update_column["label"] = "label";
    /** column name */
    TicketStatus_update_column["value"] = "value";
})(TicketStatus_update_column || (exports.TicketStatus_update_column = TicketStatus_update_column = {}));
/** unique or primary key constraints on table "TicketType" */
var TicketType_constraint;
(function (TicketType_constraint) {
    /** unique or primary key constraint on columns "label" */
    TicketType_constraint["TicketType_label_key"] = "TicketType_label_key";
    /** unique or primary key constraint on columns "value" */
    TicketType_constraint["TicketType_pkey"] = "TicketType_pkey";
})(TicketType_constraint || (exports.TicketType_constraint = TicketType_constraint = {}));
var TicketType_enum;
(function (TicketType_enum) {
    /** Smart Lock - Low Battery */
    TicketType_enum["SMART_LOCK_LOW_BATTERY"] = "SMART_LOCK_LOW_BATTERY";
    /** Turnover - Lock Reset */
    TicketType_enum["TURNOVER_LOCK_RESET"] = "TURNOVER_LOCK_RESET";
})(TicketType_enum || (exports.TicketType_enum = TicketType_enum = {}));
/** select columns of table "TicketType" */
var TicketType_select_column;
(function (TicketType_select_column) {
    /** column name */
    TicketType_select_column["label"] = "label";
    /** column name */
    TicketType_select_column["value"] = "value";
})(TicketType_select_column || (exports.TicketType_select_column = TicketType_select_column = {}));
/** update columns of table "TicketType" */
var TicketType_update_column;
(function (TicketType_update_column) {
    /** column name */
    TicketType_update_column["label"] = "label";
    /** column name */
    TicketType_update_column["value"] = "value";
})(TicketType_update_column || (exports.TicketType_update_column = TicketType_update_column = {}));
/** unique or primary key constraints on table "Ticket" */
var Ticket_constraint;
(function (Ticket_constraint) {
    /** unique or primary key constraint on columns "ticketId" */
    Ticket_constraint["Ticket_pkey"] = "Ticket_pkey";
})(Ticket_constraint || (exports.Ticket_constraint = Ticket_constraint = {}));
/** select columns of table "Ticket" */
var Ticket_select_column;
(function (Ticket_select_column) {
    /** column name */
    Ticket_select_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    Ticket_select_column["createdAt"] = "createdAt";
    /** column name */
    Ticket_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    Ticket_select_column["propertyId"] = "propertyId";
    /** column name */
    Ticket_select_column["smartLockId"] = "smartLockId";
    /** column name */
    Ticket_select_column["solvedAt"] = "solvedAt";
    /** column name */
    Ticket_select_column["solvedByUserId"] = "solvedByUserId";
    /** column name */
    Ticket_select_column["status"] = "status";
    /** column name */
    Ticket_select_column["ticketId"] = "ticketId";
    /** column name */
    Ticket_select_column["type"] = "type";
    /** column name */
    Ticket_select_column["unitId"] = "unitId";
    /** column name */
    Ticket_select_column["updatedAt"] = "updatedAt";
})(Ticket_select_column || (exports.Ticket_select_column = Ticket_select_column = {}));
/** update columns of table "Ticket" */
var Ticket_update_column;
(function (Ticket_update_column) {
    /** column name */
    Ticket_update_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    Ticket_update_column["createdAt"] = "createdAt";
    /** column name */
    Ticket_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    Ticket_update_column["propertyId"] = "propertyId";
    /** column name */
    Ticket_update_column["smartLockId"] = "smartLockId";
    /** column name */
    Ticket_update_column["solvedAt"] = "solvedAt";
    /** column name */
    Ticket_update_column["solvedByUserId"] = "solvedByUserId";
    /** column name */
    Ticket_update_column["status"] = "status";
    /** column name */
    Ticket_update_column["ticketId"] = "ticketId";
    /** column name */
    Ticket_update_column["type"] = "type";
    /** column name */
    Ticket_update_column["unitId"] = "unitId";
    /** column name */
    Ticket_update_column["updatedAt"] = "updatedAt";
})(Ticket_update_column || (exports.Ticket_update_column = Ticket_update_column = {}));
/** unique or primary key constraints on table "Timezone" */
var Timezone_constraint;
(function (Timezone_constraint) {
    /** unique or primary key constraint on columns "label" */
    Timezone_constraint["Timezone_label_key"] = "Timezone_label_key";
    /** unique or primary key constraint on columns "value" */
    Timezone_constraint["Timezone_pkey"] = "Timezone_pkey";
})(Timezone_constraint || (exports.Timezone_constraint = Timezone_constraint = {}));
/** select columns of table "Timezone" */
var Timezone_select_column;
(function (Timezone_select_column) {
    /** column name */
    Timezone_select_column["label"] = "label";
    /** column name */
    Timezone_select_column["value"] = "value";
})(Timezone_select_column || (exports.Timezone_select_column = Timezone_select_column = {}));
/** update columns of table "Timezone" */
var Timezone_update_column;
(function (Timezone_update_column) {
    /** column name */
    Timezone_update_column["label"] = "label";
    /** column name */
    Timezone_update_column["value"] = "value";
})(Timezone_update_column || (exports.Timezone_update_column = Timezone_update_column = {}));
/** unique or primary key constraints on table "UnitGroup" */
var UnitGroup_constraint;
(function (UnitGroup_constraint) {
    /** unique or primary key constraint on columns "unitGroupId" */
    UnitGroup_constraint["UnitGroup_pkey"] = "UnitGroup_pkey";
    /** unique or primary key constraint on columns "name", "propertyId" */
    UnitGroup_constraint["UnitGroup_propertyId_name_key"] = "UnitGroup_propertyId_name_key";
    /** unique or primary key constraint on columns "name", "propertyId", "parentUnitGroupId" */
    UnitGroup_constraint["UnitGroup_propertyId_parentUnitGroupId_name_key"] = "UnitGroup_propertyId_parentUnitGroupId_name_key";
    /** unique or primary key constraint on columns "sourceId" */
    UnitGroup_constraint["UnitGroup_sourceId_key"] = "UnitGroup_sourceId_key";
})(UnitGroup_constraint || (exports.UnitGroup_constraint = UnitGroup_constraint = {}));
/** select columns of table "UnitGroup" */
var UnitGroup_select_column;
(function (UnitGroup_select_column) {
    /** column name */
    UnitGroup_select_column["createdAt"] = "createdAt";
    /** column name */
    UnitGroup_select_column["name"] = "name";
    /** column name */
    UnitGroup_select_column["parentUnitGroupId"] = "parentUnitGroupId";
    /** column name */
    UnitGroup_select_column["propertyId"] = "propertyId";
    /** column name */
    UnitGroup_select_column["sourceId"] = "sourceId";
    /** column name */
    UnitGroup_select_column["unitGroupId"] = "unitGroupId";
    /** column name */
    UnitGroup_select_column["updatedAt"] = "updatedAt";
})(UnitGroup_select_column || (exports.UnitGroup_select_column = UnitGroup_select_column = {}));
/** update columns of table "UnitGroup" */
var UnitGroup_update_column;
(function (UnitGroup_update_column) {
    /** column name */
    UnitGroup_update_column["createdAt"] = "createdAt";
    /** column name */
    UnitGroup_update_column["name"] = "name";
    /** column name */
    UnitGroup_update_column["parentUnitGroupId"] = "parentUnitGroupId";
    /** column name */
    UnitGroup_update_column["propertyId"] = "propertyId";
    /** column name */
    UnitGroup_update_column["sourceId"] = "sourceId";
    /** column name */
    UnitGroup_update_column["unitGroupId"] = "unitGroupId";
    /** column name */
    UnitGroup_update_column["updatedAt"] = "updatedAt";
})(UnitGroup_update_column || (exports.UnitGroup_update_column = UnitGroup_update_column = {}));
/** unique or primary key constraints on table "UnitType" */
var UnitType_constraint;
(function (UnitType_constraint) {
    /** unique or primary key constraint on columns "value" */
    UnitType_constraint["UnitType_pkey"] = "UnitType_pkey";
})(UnitType_constraint || (exports.UnitType_constraint = UnitType_constraint = {}));
var UnitType_enum;
(function (UnitType_enum) {
    UnitType_enum["RESIDENTIAL"] = "RESIDENTIAL";
    UnitType_enum["STAFF"] = "STAFF";
})(UnitType_enum || (exports.UnitType_enum = UnitType_enum = {}));
/** select columns of table "UnitType" */
var UnitType_select_column;
(function (UnitType_select_column) {
    /** column name */
    UnitType_select_column["value"] = "value";
})(UnitType_select_column || (exports.UnitType_select_column = UnitType_select_column = {}));
/** update columns of table "UnitType" */
var UnitType_update_column;
(function (UnitType_update_column) {
    /** column name */
    UnitType_update_column["value"] = "value";
})(UnitType_update_column || (exports.UnitType_update_column = UnitType_update_column = {}));
/** unique or primary key constraints on table "Unit" */
var Unit_constraint;
(function (Unit_constraint) {
    /** unique or primary key constraint on columns "unitId" */
    Unit_constraint["Unit_pkey"] = "Unit_pkey";
    /** unique or primary key constraint on columns "unitNumber", "building", "propertyId" */
    Unit_constraint["Unit_propertyId_unitNumber_building_key"] = "Unit_propertyId_unitNumber_building_key";
    /** unique or primary key constraint on columns "unitNumber", "propertyId" */
    Unit_constraint["Unit_propertyId_unitNumber_key"] = "Unit_propertyId_unitNumber_key";
    /** unique or primary key constraint on columns "sourceId" */
    Unit_constraint["Unit_sourceId_key"] = "Unit_sourceId_key";
})(Unit_constraint || (exports.Unit_constraint = Unit_constraint = {}));
/** select columns of table "Unit" */
var Unit_select_column;
(function (Unit_select_column) {
    /** column name */
    Unit_select_column["building"] = "building";
    /** column name */
    Unit_select_column["createdAt"] = "createdAt";
    /** column name */
    Unit_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    Unit_select_column["propertyId"] = "propertyId";
    /** column name */
    Unit_select_column["sourceId"] = "sourceId";
    /** column name */
    Unit_select_column["type"] = "type";
    /** column name */
    Unit_select_column["unitGroupId"] = "unitGroupId";
    /** column name */
    Unit_select_column["unitId"] = "unitId";
    /** column name */
    Unit_select_column["unitNumber"] = "unitNumber";
    /** column name */
    Unit_select_column["updatedAt"] = "updatedAt";
})(Unit_select_column || (exports.Unit_select_column = Unit_select_column = {}));
/** update columns of table "Unit" */
var Unit_update_column;
(function (Unit_update_column) {
    /** column name */
    Unit_update_column["building"] = "building";
    /** column name */
    Unit_update_column["createdAt"] = "createdAt";
    /** column name */
    Unit_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    Unit_update_column["propertyId"] = "propertyId";
    /** column name */
    Unit_update_column["sourceId"] = "sourceId";
    /** column name */
    Unit_update_column["type"] = "type";
    /** column name */
    Unit_update_column["unitGroupId"] = "unitGroupId";
    /** column name */
    Unit_update_column["unitId"] = "unitId";
    /** column name */
    Unit_update_column["unitNumber"] = "unitNumber";
    /** column name */
    Unit_update_column["updatedAt"] = "updatedAt";
})(Unit_update_column || (exports.Unit_update_column = Unit_update_column = {}));
/** unique or primary key constraints on table "UnlockMethod" */
var UnlockMethod_constraint;
(function (UnlockMethod_constraint) {
    /** unique or primary key constraint on columns "label" */
    UnlockMethod_constraint["UnlockMethod_label_key"] = "UnlockMethod_label_key";
    /** unique or primary key constraint on columns "value" */
    UnlockMethod_constraint["UnlockMethod_pkey"] = "UnlockMethod_pkey";
})(UnlockMethod_constraint || (exports.UnlockMethod_constraint = UnlockMethod_constraint = {}));
var UnlockMethod_enum;
(function (UnlockMethod_enum) {
    /** Access App - Favorites */
    UnlockMethod_enum["ACCESS_APP_FAVORITES"] = "ACCESS_APP_FAVORITES";
    /** Access App - Nearby */
    UnlockMethod_enum["ACCESS_APP_NEARBY"] = "ACCESS_APP_NEARBY";
    /** Access App - Search */
    UnlockMethod_enum["ACCESS_APP_SEARCH"] = "ACCESS_APP_SEARCH";
    /** Access Web App */
    UnlockMethod_enum["ACCESS_WEB"] = "ACCESS_WEB";
    /** Admin Panel */
    UnlockMethod_enum["ADMIN_PANEL"] = "ADMIN_PANEL";
    /** Credential - Mobile */
    UnlockMethod_enum["CREDENTIAL_MOBILE"] = "CREDENTIAL_MOBILE";
    /** Credential - Physical */
    UnlockMethod_enum["CREDENTIAL_PHYSICAL"] = "CREDENTIAL_PHYSICAL";
    /** Credential - Unknown */
    UnlockMethod_enum["CREDENTIAL_UNKNOWN"] = "CREDENTIAL_UNKNOWN";
    /** Input Device */
    UnlockMethod_enum["INPUT_DEVICE"] = "INPUT_DEVICE";
    /** NFC */
    UnlockMethod_enum["NFC"] = "NFC";
    /** Pin Code */
    UnlockMethod_enum["PIN_CODE"] = "PIN_CODE";
    /** QR Code */
    UnlockMethod_enum["QR_CODE"] = "QR_CODE";
    /** Siri Shortcut */
    UnlockMethod_enum["SIRI_SHORTCUT"] = "SIRI_SHORTCUT";
    /** Smart Building Portal */
    UnlockMethod_enum["SMART_BUILDING_PORTAL"] = "SMART_BUILDING_PORTAL";
    /** Spaceship Mode */
    UnlockMethod_enum["SPACESHIP_MODE"] = "SPACESHIP_MODE";
    /** Widget - Favorites */
    UnlockMethod_enum["WIDGET_FAVORITES"] = "WIDGET_FAVORITES";
    /** Widget - Nearby */
    UnlockMethod_enum["WIDGET_NEARBY"] = "WIDGET_NEARBY";
})(UnlockMethod_enum || (exports.UnlockMethod_enum = UnlockMethod_enum = {}));
/** select columns of table "UnlockMethod" */
var UnlockMethod_select_column;
(function (UnlockMethod_select_column) {
    /** column name */
    UnlockMethod_select_column["label"] = "label";
    /** column name */
    UnlockMethod_select_column["value"] = "value";
})(UnlockMethod_select_column || (exports.UnlockMethod_select_column = UnlockMethod_select_column = {}));
/** update columns of table "UnlockMethod" */
var UnlockMethod_update_column;
(function (UnlockMethod_update_column) {
    /** column name */
    UnlockMethod_update_column["label"] = "label";
    /** column name */
    UnlockMethod_update_column["value"] = "value";
})(UnlockMethod_update_column || (exports.UnlockMethod_update_column = UnlockMethod_update_column = {}));
/** unique or primary key constraints on table "UnlockResult" */
var UnlockResult_constraint;
(function (UnlockResult_constraint) {
    /** unique or primary key constraint on columns "label" */
    UnlockResult_constraint["UnlockResult_label_key"] = "UnlockResult_label_key";
    /** unique or primary key constraint on columns "value" */
    UnlockResult_constraint["UnlockResult_pkey"] = "UnlockResult_pkey";
})(UnlockResult_constraint || (exports.UnlockResult_constraint = UnlockResult_constraint = {}));
var UnlockResult_enum;
(function (UnlockResult_enum) {
    /** Access Denied */
    UnlockResult_enum["ACCESS_DENIED"] = "ACCESS_DENIED";
    /** Access Granted */
    UnlockResult_enum["ACCESS_GRANTED"] = "ACCESS_GRANTED";
})(UnlockResult_enum || (exports.UnlockResult_enum = UnlockResult_enum = {}));
/** select columns of table "UnlockResult" */
var UnlockResult_select_column;
(function (UnlockResult_select_column) {
    /** column name */
    UnlockResult_select_column["label"] = "label";
    /** column name */
    UnlockResult_select_column["value"] = "value";
})(UnlockResult_select_column || (exports.UnlockResult_select_column = UnlockResult_select_column = {}));
/** update columns of table "UnlockResult" */
var UnlockResult_update_column;
(function (UnlockResult_update_column) {
    /** column name */
    UnlockResult_update_column["label"] = "label";
    /** column name */
    UnlockResult_update_column["value"] = "value";
})(UnlockResult_update_column || (exports.UnlockResult_update_column = UnlockResult_update_column = {}));
/** unique or primary key constraints on table "UserRoleGrantMethod" */
var UserRoleGrantMethod_constraint;
(function (UserRoleGrantMethod_constraint) {
    /** unique or primary key constraint on columns "value" */
    UserRoleGrantMethod_constraint["UserRoleGrantMethod_pkey"] = "UserRoleGrantMethod_pkey";
})(UserRoleGrantMethod_constraint || (exports.UserRoleGrantMethod_constraint = UserRoleGrantMethod_constraint = {}));
var UserRoleGrantMethod_enum;
(function (UserRoleGrantMethod_enum) {
    UserRoleGrantMethod_enum["CHIRP_ACCESS_APP"] = "CHIRP_ACCESS_APP";
    UserRoleGrantMethod_enum["CHIRP_ADMIN_PANEL"] = "CHIRP_ADMIN_PANEL";
    UserRoleGrantMethod_enum["CHIRP_PMS_INTEGRATION"] = "CHIRP_PMS_INTEGRATION";
    UserRoleGrantMethod_enum["REALPAGE_SGT"] = "REALPAGE_SGT";
    UserRoleGrantMethod_enum["VIRTUAL_DIRECTORY_RESIDENT_APPROVAL"] = "VIRTUAL_DIRECTORY_RESIDENT_APPROVAL";
    UserRoleGrantMethod_enum["VIRTUAL_DIRECTORY_STAFF_APPROVAL"] = "VIRTUAL_DIRECTORY_STAFF_APPROVAL";
})(UserRoleGrantMethod_enum || (exports.UserRoleGrantMethod_enum = UserRoleGrantMethod_enum = {}));
/** select columns of table "UserRoleGrantMethod" */
var UserRoleGrantMethod_select_column;
(function (UserRoleGrantMethod_select_column) {
    /** column name */
    UserRoleGrantMethod_select_column["value"] = "value";
})(UserRoleGrantMethod_select_column || (exports.UserRoleGrantMethod_select_column = UserRoleGrantMethod_select_column = {}));
/** update columns of table "UserRoleGrantMethod" */
var UserRoleGrantMethod_update_column;
(function (UserRoleGrantMethod_update_column) {
    /** column name */
    UserRoleGrantMethod_update_column["value"] = "value";
})(UserRoleGrantMethod_update_column || (exports.UserRoleGrantMethod_update_column = UserRoleGrantMethod_update_column = {}));
/** select columns of table "UserRolePermission" */
var UserRolePermission_select_column;
(function (UserRolePermission_select_column) {
    /** column name */
    UserRolePermission_select_column["anonymousUserId"] = "anonymousUserId";
    /** column name */
    UserRolePermission_select_column["permissionId"] = "permissionId";
    /** column name */
    UserRolePermission_select_column["permissionKey"] = "permissionKey";
    /** column name */
    UserRolePermission_select_column["permissionScope"] = "permissionScope";
    /** column name */
    UserRolePermission_select_column["roleId"] = "roleId";
    /** column name */
    UserRolePermission_select_column["roleKey"] = "roleKey";
    /** column name */
    UserRolePermission_select_column["scopedAccessPointId"] = "scopedAccessPointId";
    /** column name */
    UserRolePermission_select_column["scopedOrganizationId"] = "scopedOrganizationId";
    /** column name */
    UserRolePermission_select_column["scopedPropertyId"] = "scopedPropertyId";
    /** column name */
    UserRolePermission_select_column["scopedUnitId"] = "scopedUnitId";
    /** column name */
    UserRolePermission_select_column["userId"] = "userId";
    /** column name */
    UserRolePermission_select_column["userRoleId"] = "userRoleId";
})(UserRolePermission_select_column || (exports.UserRolePermission_select_column = UserRolePermission_select_column = {}));
/** unique or primary key constraints on table "UserRoleReason" */
var UserRoleReason_constraint;
(function (UserRoleReason_constraint) {
    /** unique or primary key constraint on columns "label" */
    UserRoleReason_constraint["UserRoleReason_label_key"] = "UserRoleReason_label_key";
    /** unique or primary key constraint on columns "value" */
    UserRoleReason_constraint["UserRoleReason_pkey"] = "UserRoleReason_pkey";
})(UserRoleReason_constraint || (exports.UserRoleReason_constraint = UserRoleReason_constraint = {}));
var UserRoleReason_enum;
(function (UserRoleReason_enum) {
    /** Capital Project */
    UserRoleReason_enum["CAPITAL_PROJECT"] = "CAPITAL_PROJECT";
    /** Dog Walker */
    UserRoleReason_enum["DOG_WALKER"] = "DOG_WALKER";
    /** Employee Vacation Suite */
    UserRoleReason_enum["EMPLOYEE_VACATION_SUITE"] = "EMPLOYEE_VACATION_SUITE";
    /** Gateway - Installation */
    UserRoleReason_enum["GATEWAY_INSTALLATION"] = "GATEWAY_INSTALLATION";
    /** Gateway - Service Call */
    UserRoleReason_enum["GATEWAY_SERVICE_CALL"] = "GATEWAY_SERVICE_CALL";
    /** Housekeeping */
    UserRoleReason_enum["HOUSEKEEPING"] = "HOUSEKEEPING";
    /** Inspection */
    UserRoleReason_enum["INSPECTION"] = "INSPECTION";
    /** Law Enforcement */
    UserRoleReason_enum["LAW_ENFORCEMENT"] = "LAW_ENFORCEMENT";
    /** Maintenance Emergency */
    UserRoleReason_enum["MAINTENANCE_EMERGENCY"] = "MAINTENANCE_EMERGENCY";
    /** Other */
    UserRoleReason_enum["OTHER"] = "OTHER";
    /** Package Dropoff */
    UserRoleReason_enum["PACKAGE_DROPOFF"] = "PACKAGE_DROPOFF";
    /** Pest Control */
    UserRoleReason_enum["PEST_CONTROL"] = "PEST_CONTROL";
    /** Preventative Maintenance */
    UserRoleReason_enum["PREVENTATIVE_MAINTENANCE"] = "PREVENTATIVE_MAINTENANCE";
    /** Prospect Tour */
    UserRoleReason_enum["PROSPECT_TOUR"] = "PROSPECT_TOUR";
    /** Reposition */
    UserRoleReason_enum["REPOSITION"] = "REPOSITION";
    /** Service Request */
    UserRoleReason_enum["SERVICE_REQUEST"] = "SERVICE_REQUEST";
    /** Skips and evictions */
    UserRoleReason_enum["SKIPS_AND_EVICTIONS"] = "SKIPS_AND_EVICTIONS";
    /** Smart Lock - August Connect */
    UserRoleReason_enum["SMART_LOCK_AUGUST_CONNECT"] = "SMART_LOCK_AUGUST_CONNECT";
    /** Smart Lock - Low Battery */
    UserRoleReason_enum["SMART_LOCK_LOW_BATTERY"] = "SMART_LOCK_LOW_BATTERY";
    /** Smart Lock - Provisioning */
    UserRoleReason_enum["SMART_LOCK_PROVISIONING"] = "SMART_LOCK_PROVISIONING";
    /** Smart Lock - Connect and Sync Data */
    UserRoleReason_enum["SMART_LOCK_SYNC"] = "SMART_LOCK_SYNC";
    /** Smart Lock - Troubleshooting */
    UserRoleReason_enum["SMART_LOCK_TROUBLESHOOTING"] = "SMART_LOCK_TROUBLESHOOTING";
    /** Third Party Services */
    UserRoleReason_enum["THIRD_PARTY_SERVICES"] = "THIRD_PARTY_SERVICES";
    /** Turnover - Clean */
    UserRoleReason_enum["TURNOVER_CLEAN"] = "TURNOVER_CLEAN";
    /** Turnover - Floor Clean */
    UserRoleReason_enum["TURNOVER_FLOOR_CLEAN"] = "TURNOVER_FLOOR_CLEAN";
    /** Turnover - Lock Reset */
    UserRoleReason_enum["TURNOVER_LOCK_RESET"] = "TURNOVER_LOCK_RESET";
    /** Turnover - Maintenance */
    UserRoleReason_enum["TURNOVER_MAINTENANCE"] = "TURNOVER_MAINTENANCE";
    /** Turnover - Other */
    UserRoleReason_enum["TURNOVER_OTHER"] = "TURNOVER_OTHER";
    /** Turnover - Paint */
    UserRoleReason_enum["TURNOVER_PAINT"] = "TURNOVER_PAINT";
    /** Welfare Check */
    UserRoleReason_enum["WELFARE_CHECK"] = "WELFARE_CHECK";
})(UserRoleReason_enum || (exports.UserRoleReason_enum = UserRoleReason_enum = {}));
/** select columns of table "UserRoleReason" */
var UserRoleReason_select_column;
(function (UserRoleReason_select_column) {
    /** column name */
    UserRoleReason_select_column["label"] = "label";
    /** column name */
    UserRoleReason_select_column["value"] = "value";
})(UserRoleReason_select_column || (exports.UserRoleReason_select_column = UserRoleReason_select_column = {}));
/** update columns of table "UserRoleReason" */
var UserRoleReason_update_column;
(function (UserRoleReason_update_column) {
    /** column name */
    UserRoleReason_update_column["label"] = "label";
    /** column name */
    UserRoleReason_update_column["value"] = "value";
})(UserRoleReason_update_column || (exports.UserRoleReason_update_column = UserRoleReason_update_column = {}));
/** unique or primary key constraints on table "UserRoleStatus" */
var UserRoleStatus_constraint;
(function (UserRoleStatus_constraint) {
    /** unique or primary key constraint on columns "label" */
    UserRoleStatus_constraint["UserRoleStatus_label_key"] = "UserRoleStatus_label_key";
    /** unique or primary key constraint on columns "value" */
    UserRoleStatus_constraint["UserRoleStatus_pkey"] = "UserRoleStatus_pkey";
})(UserRoleStatus_constraint || (exports.UserRoleStatus_constraint = UserRoleStatus_constraint = {}));
var UserRoleStatus_enum;
(function (UserRoleStatus_enum) {
    /** Active */
    UserRoleStatus_enum["ACTIVE"] = "ACTIVE";
    /** Expired */
    UserRoleStatus_enum["EXPIRED"] = "EXPIRED";
    /** Pending */
    UserRoleStatus_enum["PENDING"] = "PENDING";
    /** Revoked */
    UserRoleStatus_enum["REVOKED"] = "REVOKED";
})(UserRoleStatus_enum || (exports.UserRoleStatus_enum = UserRoleStatus_enum = {}));
/** select columns of table "UserRoleStatus" */
var UserRoleStatus_select_column;
(function (UserRoleStatus_select_column) {
    /** column name */
    UserRoleStatus_select_column["label"] = "label";
    /** column name */
    UserRoleStatus_select_column["value"] = "value";
})(UserRoleStatus_select_column || (exports.UserRoleStatus_select_column = UserRoleStatus_select_column = {}));
/** update columns of table "UserRoleStatus" */
var UserRoleStatus_update_column;
(function (UserRoleStatus_update_column) {
    /** column name */
    UserRoleStatus_update_column["label"] = "label";
    /** column name */
    UserRoleStatus_update_column["value"] = "value";
})(UserRoleStatus_update_column || (exports.UserRoleStatus_update_column = UserRoleStatus_update_column = {}));
/** unique or primary key constraints on table "UserRole" */
var UserRole_constraint;
(function (UserRole_constraint) {
    /** unique or primary key constraint on columns "userRoleId" */
    UserRole_constraint["UserRole_pkey"] = "UserRole_pkey";
    /** unique or primary key constraint on columns "sourceId" */
    UserRole_constraint["UserRole_sourceId_key"] = "UserRole_sourceId_key";
})(UserRole_constraint || (exports.UserRole_constraint = UserRole_constraint = {}));
/** select columns of table "UserRole" */
var UserRole_select_column;
(function (UserRole_select_column) {
    /** column name */
    UserRole_select_column["activatesAt"] = "activatesAt";
    /** column name */
    UserRole_select_column["assignedToAnonymousUserId"] = "assignedToAnonymousUserId";
    /** column name */
    UserRole_select_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    UserRole_select_column["createdAt"] = "createdAt";
    /** column name */
    UserRole_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    UserRole_select_column["expiresAt"] = "expiresAt";
    /** column name */
    UserRole_select_column["grantMethod"] = "grantMethod";
    /** column name */
    UserRole_select_column["managedWithinOrganizationId"] = "managedWithinOrganizationId";
    /** column name */
    UserRole_select_column["managedWithinPropertyId"] = "managedWithinPropertyId";
    /** column name */
    UserRole_select_column["nickname"] = "nickname";
    /** column name */
    UserRole_select_column["notes"] = "notes";
    /** column name */
    UserRole_select_column["parentUserRoleId"] = "parentUserRoleId";
    /** column name */
    UserRole_select_column["reason"] = "reason";
    /** column name */
    UserRole_select_column["revokedAt"] = "revokedAt";
    /** column name */
    UserRole_select_column["revokedByUserId"] = "revokedByUserId";
    /** column name */
    UserRole_select_column["roleId"] = "roleId";
    /** column name */
    UserRole_select_column["schedule"] = "schedule";
    /** column name */
    UserRole_select_column["scopedAccessPointId"] = "scopedAccessPointId";
    /** column name */
    UserRole_select_column["scopedOrganizationId"] = "scopedOrganizationId";
    /** column name */
    UserRole_select_column["scopedPropertyId"] = "scopedPropertyId";
    /** column name */
    UserRole_select_column["scopedSmartLockId"] = "scopedSmartLockId";
    /** column name */
    UserRole_select_column["scopedUnitId"] = "scopedUnitId";
    /** column name */
    UserRole_select_column["sourceId"] = "sourceId";
    /** column name */
    UserRole_select_column["sourcePayload"] = "sourcePayload";
    /** column name */
    UserRole_select_column["status"] = "status";
    /** column name */
    UserRole_select_column["updatedAt"] = "updatedAt";
    /** column name */
    UserRole_select_column["userRoleId"] = "userRoleId";
})(UserRole_select_column || (exports.UserRole_select_column = UserRole_select_column = {}));
/** update columns of table "UserRole" */
var UserRole_update_column;
(function (UserRole_update_column) {
    /** column name */
    UserRole_update_column["activatesAt"] = "activatesAt";
    /** column name */
    UserRole_update_column["assignedToAnonymousUserId"] = "assignedToAnonymousUserId";
    /** column name */
    UserRole_update_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    UserRole_update_column["createdAt"] = "createdAt";
    /** column name */
    UserRole_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    UserRole_update_column["expiresAt"] = "expiresAt";
    /** column name */
    UserRole_update_column["grantMethod"] = "grantMethod";
    /** column name */
    UserRole_update_column["managedWithinOrganizationId"] = "managedWithinOrganizationId";
    /** column name */
    UserRole_update_column["managedWithinPropertyId"] = "managedWithinPropertyId";
    /** column name */
    UserRole_update_column["nickname"] = "nickname";
    /** column name */
    UserRole_update_column["notes"] = "notes";
    /** column name */
    UserRole_update_column["parentUserRoleId"] = "parentUserRoleId";
    /** column name */
    UserRole_update_column["reason"] = "reason";
    /** column name */
    UserRole_update_column["revokedAt"] = "revokedAt";
    /** column name */
    UserRole_update_column["revokedByUserId"] = "revokedByUserId";
    /** column name */
    UserRole_update_column["roleId"] = "roleId";
    /** column name */
    UserRole_update_column["schedule"] = "schedule";
    /** column name */
    UserRole_update_column["scopedAccessPointId"] = "scopedAccessPointId";
    /** column name */
    UserRole_update_column["scopedOrganizationId"] = "scopedOrganizationId";
    /** column name */
    UserRole_update_column["scopedPropertyId"] = "scopedPropertyId";
    /** column name */
    UserRole_update_column["scopedSmartLockId"] = "scopedSmartLockId";
    /** column name */
    UserRole_update_column["scopedUnitId"] = "scopedUnitId";
    /** column name */
    UserRole_update_column["sourceId"] = "sourceId";
    /** column name */
    UserRole_update_column["sourcePayload"] = "sourcePayload";
    /** column name */
    UserRole_update_column["status"] = "status";
    /** column name */
    UserRole_update_column["updatedAt"] = "updatedAt";
    /** column name */
    UserRole_update_column["userRoleId"] = "userRoleId";
})(UserRole_update_column || (exports.UserRole_update_column = UserRole_update_column = {}));
/** unique or primary key constraints on table "User" */
var User_constraint;
(function (User_constraint) {
    /** unique or primary key constraint on columns "augustSubUserId" */
    User_constraint["User_augustSubUserId_key"] = "User_augustSubUserId_key";
    /** unique or primary key constraint on columns "augustUserId" */
    User_constraint["User_augustUserId_key"] = "User_augustUserId_key";
    /** unique or primary key constraint on columns "email" */
    User_constraint["User_email_key"] = "User_email_key";
    /** unique or primary key constraint on columns "phoneNumber" */
    User_constraint["User_phoneNumber_key"] = "User_phoneNumber_key";
    /** unique or primary key constraint on columns "userId" */
    User_constraint["User_pkey"] = "User_pkey";
})(User_constraint || (exports.User_constraint = User_constraint = {}));
/** select columns of table "User" */
var User_select_column;
(function (User_select_column) {
    /** column name */
    User_select_column["acceptedEulaAt"] = "acceptedEulaAt";
    /** column name */
    User_select_column["accountStatus"] = "accountStatus";
    /** column name */
    User_select_column["augustSubUserId"] = "augustSubUserId";
    /** column name */
    User_select_column["augustUserId"] = "augustUserId";
    /** column name */
    User_select_column["createdAt"] = "createdAt";
    /** column name */
    User_select_column["email"] = "email";
    /** column name */
    User_select_column["firstName"] = "firstName";
    /** column name */
    User_select_column["hasAugustPassword"] = "hasAugustPassword";
    /** column name */
    User_select_column["lastName"] = "lastName";
    /** column name */
    User_select_column["lastReadAnnouncementsAt"] = "lastReadAnnouncementsAt";
    /** column name */
    User_select_column["phoneNumber"] = "phoneNumber";
    /** column name */
    User_select_column["updatedAt"] = "updatedAt";
    /** column name */
    User_select_column["userId"] = "userId";
    /** column name */
    User_select_column["virtualDirectoryEnabled"] = "virtualDirectoryEnabled";
})(User_select_column || (exports.User_select_column = User_select_column = {}));
/** select "User_aggregate_bool_exp_bool_and_arguments_columns" columns of table "User" */
var User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns;
(function (User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns) {
    /** column name */
    User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns["hasAugustPassword"] = "hasAugustPassword";
    /** column name */
    User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns["virtualDirectoryEnabled"] = "virtualDirectoryEnabled";
})(User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns || (exports.User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns = User_select_column_User_aggregate_bool_exp_bool_and_arguments_columns = {}));
/** select "User_aggregate_bool_exp_bool_or_arguments_columns" columns of table "User" */
var User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns;
(function (User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns) {
    /** column name */
    User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns["hasAugustPassword"] = "hasAugustPassword";
    /** column name */
    User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns["virtualDirectoryEnabled"] = "virtualDirectoryEnabled";
})(User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns || (exports.User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns = User_select_column_User_aggregate_bool_exp_bool_or_arguments_columns = {}));
/** update columns of table "User" */
var User_update_column;
(function (User_update_column) {
    /** column name */
    User_update_column["acceptedEulaAt"] = "acceptedEulaAt";
    /** column name */
    User_update_column["accountStatus"] = "accountStatus";
    /** column name */
    User_update_column["augustSubUserId"] = "augustSubUserId";
    /** column name */
    User_update_column["augustUserId"] = "augustUserId";
    /** column name */
    User_update_column["createdAt"] = "createdAt";
    /** column name */
    User_update_column["email"] = "email";
    /** column name */
    User_update_column["firstName"] = "firstName";
    /** column name */
    User_update_column["hasAugustPassword"] = "hasAugustPassword";
    /** column name */
    User_update_column["lastName"] = "lastName";
    /** column name */
    User_update_column["lastReadAnnouncementsAt"] = "lastReadAnnouncementsAt";
    /** column name */
    User_update_column["phoneNumber"] = "phoneNumber";
    /** column name */
    User_update_column["updatedAt"] = "updatedAt";
    /** column name */
    User_update_column["userId"] = "userId";
    /** column name */
    User_update_column["virtualDirectoryEnabled"] = "virtualDirectoryEnabled";
})(User_update_column || (exports.User_update_column = User_update_column = {}));
/** unique or primary key constraints on table "VendorPasscode" */
var VendorPasscode_constraint;
(function (VendorPasscode_constraint) {
    /** unique or primary key constraint on columns "assignedToUserId" */
    VendorPasscode_constraint["VendorPasscode_assignedToUserId_key"] = "VendorPasscode_assignedToUserId_key";
    /** unique or primary key constraint on columns "code" */
    VendorPasscode_constraint["VendorPasscode_code_key"] = "VendorPasscode_code_key";
    /** unique or primary key constraint on columns "vendorPasscodeId" */
    VendorPasscode_constraint["VendorPasscode_pkey"] = "VendorPasscode_pkey";
})(VendorPasscode_constraint || (exports.VendorPasscode_constraint = VendorPasscode_constraint = {}));
/** select columns of table "VendorPasscode" */
var VendorPasscode_select_column;
(function (VendorPasscode_select_column) {
    /** column name */
    VendorPasscode_select_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    VendorPasscode_select_column["code"] = "code";
    /** column name */
    VendorPasscode_select_column["createdAt"] = "createdAt";
    /** column name */
    VendorPasscode_select_column["createdByUserId"] = "createdByUserId";
    /** column name */
    VendorPasscode_select_column["updatedAt"] = "updatedAt";
    /** column name */
    VendorPasscode_select_column["updatedByUserId"] = "updatedByUserId";
    /** column name */
    VendorPasscode_select_column["vendorPasscodeId"] = "vendorPasscodeId";
})(VendorPasscode_select_column || (exports.VendorPasscode_select_column = VendorPasscode_select_column = {}));
/** update columns of table "VendorPasscode" */
var VendorPasscode_update_column;
(function (VendorPasscode_update_column) {
    /** column name */
    VendorPasscode_update_column["assignedToUserId"] = "assignedToUserId";
    /** column name */
    VendorPasscode_update_column["code"] = "code";
    /** column name */
    VendorPasscode_update_column["createdAt"] = "createdAt";
    /** column name */
    VendorPasscode_update_column["createdByUserId"] = "createdByUserId";
    /** column name */
    VendorPasscode_update_column["updatedAt"] = "updatedAt";
    /** column name */
    VendorPasscode_update_column["updatedByUserId"] = "updatedByUserId";
    /** column name */
    VendorPasscode_update_column["vendorPasscodeId"] = "vendorPasscodeId";
})(VendorPasscode_update_column || (exports.VendorPasscode_update_column = VendorPasscode_update_column = {}));
/** unique or primary key constraints on table "VirtualDirectoryUserDisplayNameFormat" */
var VirtualDirectoryUserDisplayNameFormat_constraint;
(function (VirtualDirectoryUserDisplayNameFormat_constraint) {
    /** unique or primary key constraint on columns "value" */
    VirtualDirectoryUserDisplayNameFormat_constraint["VirtualDirectoryUserDisplayNameFormat_pkey"] = "VirtualDirectoryUserDisplayNameFormat_pkey";
})(VirtualDirectoryUserDisplayNameFormat_constraint || (exports.VirtualDirectoryUserDisplayNameFormat_constraint = VirtualDirectoryUserDisplayNameFormat_constraint = {}));
var VirtualDirectoryUserDisplayNameFormat_enum;
(function (VirtualDirectoryUserDisplayNameFormat_enum) {
    VirtualDirectoryUserDisplayNameFormat_enum["ANONYMOUS"] = "ANONYMOUS";
    VirtualDirectoryUserDisplayNameFormat_enum["FIRST_INITIAL_LAST_INITIAL"] = "FIRST_INITIAL_LAST_INITIAL";
    VirtualDirectoryUserDisplayNameFormat_enum["FIRST_INITIAL_LAST_NAME"] = "FIRST_INITIAL_LAST_NAME";
    VirtualDirectoryUserDisplayNameFormat_enum["FIRST_NAME_LAST_INITIAL"] = "FIRST_NAME_LAST_INITIAL";
    VirtualDirectoryUserDisplayNameFormat_enum["FIRST_NAME_LAST_NAME"] = "FIRST_NAME_LAST_NAME";
})(VirtualDirectoryUserDisplayNameFormat_enum || (exports.VirtualDirectoryUserDisplayNameFormat_enum = VirtualDirectoryUserDisplayNameFormat_enum = {}));
/** select columns of table "VirtualDirectoryUserDisplayNameFormat" */
var VirtualDirectoryUserDisplayNameFormat_select_column;
(function (VirtualDirectoryUserDisplayNameFormat_select_column) {
    /** column name */
    VirtualDirectoryUserDisplayNameFormat_select_column["value"] = "value";
})(VirtualDirectoryUserDisplayNameFormat_select_column || (exports.VirtualDirectoryUserDisplayNameFormat_select_column = VirtualDirectoryUserDisplayNameFormat_select_column = {}));
/** update columns of table "VirtualDirectoryUserDisplayNameFormat" */
var VirtualDirectoryUserDisplayNameFormat_update_column;
(function (VirtualDirectoryUserDisplayNameFormat_update_column) {
    /** column name */
    VirtualDirectoryUserDisplayNameFormat_update_column["value"] = "value";
})(VirtualDirectoryUserDisplayNameFormat_update_column || (exports.VirtualDirectoryUserDisplayNameFormat_update_column = VirtualDirectoryUserDisplayNameFormat_update_column = {}));
/** ordering argument of a cursor */
var cursor_ordering;
(function (cursor_ordering) {
    /** ascending ordering of the cursor */
    cursor_ordering["ASC"] = "ASC";
    /** descending ordering of the cursor */
    cursor_ordering["DESC"] = "DESC";
})(cursor_ordering || (exports.cursor_ordering = cursor_ordering = {}));
/** column ordering options */
var order_by;
(function (order_by) {
    /** in ascending order, nulls last */
    order_by["asc"] = "asc";
    /** in ascending order, nulls first */
    order_by["asc_nulls_first"] = "asc_nulls_first";
    /** in ascending order, nulls last */
    order_by["asc_nulls_last"] = "asc_nulls_last";
    /** in descending order, nulls first */
    order_by["desc"] = "desc";
    /** in descending order, nulls first */
    order_by["desc_nulls_first"] = "desc_nulls_first";
    /** in descending order, nulls last */
    order_by["desc_nulls_last"] = "desc_nulls_last";
})(order_by || (exports.order_by = order_by = {}));
//# sourceMappingURL=generated.js.map